'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var preact = require('preact');
var preact__default = _interopDefault(preact);
var classNames = _interopDefault(require('classnames'));
var index_js = require('../components/index.js');
var index_js$1 = require('../utils/index.js');
var throttle = _interopDefault(require('lodash.throttle'));
require('../cursor/index.js');
require('prosemirror-transform');
require('prosemirror-model');
require('prosemirror-state');
var index_js$3 = require('../table/index.js');

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

class MenuItemWrapper extends preact.Component {
  constructor(...args) {
    super(...args);
    this.container = void 0;
  }

  componentDidMount() {
    const {
      getRef
    } = this.props;

    if (getRef) {
      getRef(this.container);
    }
  }

  render() {
    const {
      children,
      isMore
    } = this.props;
    return preact.h("div", {
      className: `menu-item-wrapper${isMore ? " more" : ""}`,
      ref: container => {
        this.container = container;
      }
    }, children);
  }

} // tslint:disable-next-line: max-classes-per-file

class MenuItem extends preact.Component {
  render() {
    const _this$props = this.props,
          {
      type
    } = _this$props,
          restProps = objectWithoutProperties(_this$props, ["type"]);

    if (type === "extra") {
      return preact.h(ExtraItem, restProps);
    }

    return preact.h(HeaderMenuItem, restProps);
  }

} // tslint:disable-next-line: max-classes-per-file

class HeaderMenuItem extends preact.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasTooltip: false
    };

    this.handleClick = e => {
      const {
        disabledHandler,
        onClick
      } = this.props;
      const disabled = disabledHandler && disabledHandler();

      if (disabled) {
        return;
      }

      if (onClick) {
        onClick(e);
      }
    };
  }

  render() {
    const {
      action,
      tooltip,
      activeHandler,
      disabledHandler,
      children
    } = this.props;
    const disabled = disabledHandler && disabledHandler();
    const iconClassNames = classNames({
      "active": activeHandler && activeHandler(),
      disabled,
      "menu-item": true
    });
    return preact.h("div", {
      className: iconClassNames,
      onMouseEnter: () => {
        if (disabled) {
          return;
        }

        this.setState({
          hasTooltip: true
        });
      },
      onMouseLeave: () => this.setState({
        hasTooltip: false
      }),
      onClick: this.handleClick
    }, preact.h("span", {
      className: "toolbar-icon-wrapper",
      "data-action": action
    }), children, this.state.hasTooltip && tooltip && preact.h("div", {
      className: "toolbar-tooltip"
    }, tooltip));
  }

} // tslint:disable-next-line: max-classes-per-file

class ExtraItem extends preact.Component {
  render() {
    const _this$props2 = this.props,
          {
      action,
      tooltip
    } = _this$props2,
          restProps = objectWithoutProperties(_this$props2, ["action", "tooltip"]);

    return preact.h("div", _extends_1({
      className: "menu-item"
    }, restProps), action ? preact.h("span", {
      "data-action": action,
      className: "toolbar-icon-wrapper"
    }) : "", preact.h("span", null, tooltip));
  }

}
const handleListClick = (listType, editorCore) => {
  const {
    listCommands,
    listUtils,
    view
  } = editorCore;

  if (listUtils.judgeListType(view.state, listType)) {
    listCommands.unwrapList();
  } else if (!listUtils.isInList(view.state)) {
    listCommands.wrapInList(listType);
  } else {
    listCommands.transformList(listType);
  }

  view.focus();
};
const caculatePopoverPos = (mountNode, popover) => {
  const top = mountNode.offsetTop;
  let left = mountNode.offsetWidth;
  const rect = mountNode.getBoundingClientRect();
  const innerWidth = window.innerWidth;

  if (innerWidth - rect.right < 100 && popover) {
    left = -popover.offsetWidth;
  }

  return {
    left: `${left}px`,
    top: `${top - 10}px`
  };
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".toolbar-color-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:40px;font-size:12px;cursor:pointer;transition:all .2s ease}.toolbar-color-popover-wrapper.disabled{cursor:not-allowed}.toolbar-color-popover-wrapper.disabled path{fill:#aaa}.toolbar-color-popover-wrapper .left{width:26px;height:100%}.toolbar-color-popover-wrapper .right{width:14px;height:100%;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 50%}.toolbar-color-popover-wrapper.font-color{position:relative}.toolbar-color-popover-wrapper.font-color .left{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.62 5.902L5.01 1.484 3.302 5.902H6.62zM4.26 0h1.624l3.844 10H8.156L7.08 7.005H2.89L1.743 10H.272L4.26 0z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 7px 7px}.toolbar-color-popover-wrapper.font-color .left .color{position:absolute;left:5px;bottom:7px;width:14px;height:2px;border:1px solid;margin:0 auto}.toolbar-color-popover-wrapper.bg-color .left{position:relative}.toolbar-color-popover-wrapper.bg-color .color{position:absolute;top:18px;left:5px;width:14px;height:2px}.toolbar-color-popover-wrapper.border-color{width:246px}.toolbar-color-popover{display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;position:absolute;width:258px;height:150px;bottom:-152px;left:0;padding:8px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.toolbar-color-popover .default{position:relative;width:calc(100% - 2px);margin:0 1px 8px;height:24px;border:1px solid #ddd;border-radius:2px;cursor:pointer}.toolbar-color-popover .color-grid{position:absolute;top:5px;left:10px;width:13px;height:13px;border:1px solid}.toolbar-color-popover .text{height:24px;line-height:24px;text-align:center;font-size:12px;color:#333}.toolbar-color-grid{margin:0 2px;width:16px;height:16px;cursor:pointer}.toolbar-color-grid:nth-child(2),.toolbar-color-grid:nth-child(12){border:1px solid #eee}.toolbar-color-grid.selected{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.toolbar-color-grid:hover{z-index:3;border-radius:1px;border:1px solid #fff}.toolbar-color-grid:hover:nth-child(3){box-shadow:0 0 0 2px #333}.toolbar-color-grid:hover:nth-child(4){box-shadow:0 0 0 2px #f5222d}.toolbar-color-grid:hover:nth-child(5){box-shadow:0 0 0 2px #fa541c}.toolbar-color-grid:hover:nth-child(6){box-shadow:0 0 0 2px #faad14}.toolbar-color-grid:hover:nth-child(7){box-shadow:0 0 0 2px #fadb14}.toolbar-color-grid:hover:nth-child(8){box-shadow:0 0 0 2px #52c41a}.toolbar-color-grid:hover:nth-child(9){box-shadow:0 0 0 2px #13c2c2}.toolbar-color-grid:hover:nth-child(10){box-shadow:0 0 0 2px #1890ff}.toolbar-color-grid:hover:nth-child(11){box-shadow:0 0 0 2px #2f54eb}.toolbar-color-grid:hover:nth-child(12){box-shadow:0 0 0 2px #722ed1}.toolbar-color-grid:hover:nth-child(13){box-shadow:0 0 0 2px #eb2f96}.toolbar-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #f6f6f6}.toolbar-color-grid:hover:nth-child(15){box-shadow:0 0 0 2px #989898}.toolbar-color-grid:hover:nth-child(16){box-shadow:0 0 0 2px #ffe8e7}.toolbar-color-grid:hover:nth-child(17){box-shadow:0 0 0 2px #ffece0}.toolbar-color-grid:hover:nth-child(18){box-shadow:0 0 0 2px #fff7cb}.toolbar-color-grid:hover:nth-child(19){box-shadow:0 0 0 2px #fcfcca}.toolbar-color-grid:hover:nth-child(20){box-shadow:0 0 0 2px #e5f7d3}.toolbar-color-grid:hover:nth-child(21){box-shadow:0 0 0 2px #cffff7}.toolbar-color-grid:hover:nth-child(22){box-shadow:0 0 0 2px #d4eefc}.toolbar-color-grid:hover:nth-child(23){box-shadow:0 0 0 2px #dfe8fc}.toolbar-color-grid:hover:nth-child(24){box-shadow:0 0 0 2px #efe1fa}.toolbar-color-grid:hover:nth-child(25){box-shadow:0 0 0 2px #fbe1eb}.toolbar-color-grid:hover:nth-child(26){box-shadow:0 0 0 2px #e9e9e9}.toolbar-color-grid:hover:nth-child(27){box-shadow:0 0 0 2px #666}.toolbar-color-grid:hover:nth-child(28){box-shadow:0 0 0 2px #ffa39e}.toolbar-color-grid:hover:nth-child(29){box-shadow:0 0 0 2px #ffbb96}.toolbar-color-grid:hover:nth-child(30){box-shadow:0 0 0 2px #ffe58f}.toolbar-color-grid:hover:nth-child(31){box-shadow:0 0 0 2px #fffb8f}.toolbar-color-grid:hover:nth-child(32){box-shadow:0 0 0 2px #b7eb8f}.toolbar-color-grid:hover:nth-child(33){box-shadow:0 0 0 2px #87e8de}.toolbar-color-grid:hover:nth-child(34){box-shadow:0 0 0 2px #91d5ff}.toolbar-color-grid:hover:nth-child(35){box-shadow:0 0 0 2px #adc6ff}.toolbar-color-grid:hover:nth-child(36){box-shadow:0 0 0 2px #d3adf7}.toolbar-color-grid:hover:nth-child(37){box-shadow:0 0 0 2px #ffadd2}.toolbar-color-grid:hover:nth-child(38){box-shadow:0 0 0 2px #ddd}.toolbar-color-grid:hover:nth-child(39){box-shadow:0 0 0 2px #4b4b4b}.toolbar-color-grid:hover:nth-child(40){box-shadow:0 0 0 2px #ff4d4f}.toolbar-color-grid:hover:nth-child(41){box-shadow:0 0 0 2px #ff7a45}.toolbar-color-grid:hover:nth-child(42){box-shadow:0 0 0 2px #ffc53d}.toolbar-color-grid:hover:nth-child(43){box-shadow:0 0 0 2px #ffec3d}.toolbar-color-grid:hover:nth-child(44){box-shadow:0 0 0 2px #73d13d}.toolbar-color-grid:hover:nth-child(45){box-shadow:0 0 0 2px #36cfc9}.toolbar-color-grid:hover:nth-child(46){box-shadow:0 0 0 2px #40a8ff}.toolbar-color-grid:hover:nth-child(47){box-shadow:0 0 0 2px #597ef7}.toolbar-color-grid:hover:nth-child(48){box-shadow:0 0 0 2px #9254de}.toolbar-color-grid:hover:nth-child(49){box-shadow:0 0 0 2px #f759ab}.toolbar-color-grid:hover:nth-child(50){box-shadow:0 0 0 2px #ccc}.toolbar-color-grid:hover:nth-child(51){box-shadow:0 0 0 2px #262626}.toolbar-color-grid:hover:nth-child(52){box-shadow:0 0 0 2px #cf1322}.toolbar-color-grid:hover:nth-child(53){box-shadow:0 0 0 2px #d4380d}.toolbar-color-grid:hover:nth-child(54){box-shadow:0 0 0 2px #d48806}.toolbar-color-grid:hover:nth-child(55){box-shadow:0 0 0 2px #d4b106}.toolbar-color-grid:hover:nth-child(56){box-shadow:0 0 0 2px #389e0d}.toolbar-color-grid:hover:nth-child(57){box-shadow:0 0 0 2px #08979c}.toolbar-color-grid:hover:nth-child(58){box-shadow:0 0 0 2px #096dd9}.toolbar-color-grid:hover:nth-child(59){box-shadow:0 0 0 2px #1d39c4}.toolbar-color-grid:hover:nth-child(60){box-shadow:0 0 0 2px #531dab}.toolbar-color-grid:hover:nth-child(61){box-shadow:0 0 0 2px #c41d7f}.toolbar-color-grid:hover:nth-child(62){box-shadow:0 0 0 2px #aaa}.toolbar-color-grid:hover:nth-child(63){box-shadow:0 0 0 2px #000}.toolbar-color-grid:hover:nth-child(64){box-shadow:0 0 0 2px #820014}.toolbar-color-grid:hover:nth-child(65){box-shadow:0 0 0 2px #871400}.toolbar-color-grid:hover:nth-child(66){box-shadow:0 0 0 2px #874d00}.toolbar-color-grid:hover:nth-child(67){box-shadow:0 0 0 2px #876800}.toolbar-color-grid:hover:nth-child(68){box-shadow:0 0 0 2px #135200}.toolbar-color-grid:hover:nth-child(69){box-shadow:0 0 0 2px #00474f}.toolbar-color-grid:hover:nth-child(70){box-shadow:0 0 0 2px #003a8c}.toolbar-color-grid:hover:nth-child(71){box-shadow:0 0 0 2px #061178}.toolbar-color-grid:hover:nth-child(72){box-shadow:0 0 0 2px #22075e}.toolbar-color-grid:hover:nth-child(73){box-shadow:0 0 0 2px #780650}.toolbar-color-grid:hover:nth-child(2),.toolbar-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #aaa}";
styleInject(css);

/** @jsx h */
const colors = ["#fff", "#333", "#f5222d", "#fa541c", "#faad14", "#fadb14", "#52c41a", "#13c2c2", "#1890ff", "#2f54eb", "#722ed1", "#eb2f96", "#f6f6f6", "#989898", "#ffe8e7", "#ffece0", "#fff7cb", "#fcfcca", "#e5f7d3", "#cffff7", "#d4eefc", "#dfe8fc", "#efe1fa", "#fbe1eb", "#e9e9e9", "#666", "#ffa39e", "#ffbb96", "#ffe58f", "#fffb8f", "#b7eb8f", "#87e8de", "#91d5ff", "#adc6ff", "#d3adf7", "#ffadd2", "#ddd", "#4b4b4b", "#ff4d4f", "#ff7a45", "#ffc53d", "#ffec3d", "#73d13d", "#36cfc9", "#40a8ff", "#597ef7", "#9254de", "#f759ab", "#ccc", "#262626", "#cf1322", "#d4380d", "#d48806", "#d4b106", "#389e0d", "#08979c", "#096dd9", "#1d39c4", "#531dab", "#c41d7f", "#aaa", "#000", "#820014", "#871400", "#874d00", "#876800", "#135200", "#00474f", "#003a8c", "#061178", "#22075e", "#780650"];
const colorTypes = [{
  defaultBg: "#333",
  defaultBorder: "#333",
  tip: "文字颜色",
  type: "font"
}, {
  defaultBg: "#fff",
  defaultBorder: "#eee",
  tip: "表格底色",
  type: "bg"
}, {
  defaultBg: "#ccc",
  defaultBorder: "#ccc",
  tip: "边框颜色",
  type: "border"
}];

class Popover extends preact.Component {
  render() {
    const {
      typeInfo,
      select,
      selected,
      displayPos
    } = this.props;
    const colorGrids = colors.map(color => preact.h("div", {
      key: color,
      style: {
        background: color
      },
      onClick: () => select(color),
      className: classNames("toolbar-color-grid", {
        selected: selected === color
      })
    }));
    return preact.h("div", {
      "data-action": `${typeInfo.type}Color`,
      className: "toolbar-color-popover",
      style: displayPos
    }, preact.h("div", {
      onClick: () => select(null),
      className: "default"
    }, preact.h("div", {
      style: {
        background: typeInfo.defaultBg,
        borderColor: typeInfo.defaultBorder
      },
      className: "color-grid"
    }), preact.h("div", {
      className: "text"
    }, "\u6062\u590D\u9ED8\u8BA4")), colorGrids);
  }

}

class ColorPopover extends preact.Component {
  constructor(props) {
    super(props);

    this.onSelect = color => {
      const {
        type,
        setSelected,
        setColor,
        editorCore
      } = this.props;
      const {
        view,
        basicCommands
      } = editorCore;

      if (type === "font") {
        if (color === null) {
          basicCommands.setTextDefaultColor();
        } else {
          basicCommands.setTextColor(color);
        }
      }

      if (setSelected) {
        setSelected(color);
      }

      if (setColor) {
        setColor(color);
      }

      view.focus(); // HACK 异步 setState 以确保 tooltip 关闭

      window.requestAnimationFrame(() => {
        this.setState({
          hasTooltip: false,
          isOpen: false,
          selected: color
        });
      });
    };

    this.hidePopover = e => {
      if (!e || e && e.target && !this.container.contains(e.target)) {
        this.setState({
          hasTooltip: false,
          isOpen: false
        });
        window.removeEventListener("click", this.hidePopover);
      }
    };

    this.setColor = () => {
      const {
        type,
        editorCore,
        setColor
      } = this.props;
      const {
        view,
        basicCommands
      } = editorCore;

      if (type === "font") {
        basicCommands.setTextColor(this.state.selected);
      }

      if (setColor) {
        setColor(this.state.selected);
      }

      view.focus();
    };

    this.handleClick = e => {
      const {
        editorCore,
        disabledHandler
      } = this.props;
      const {
        view
      } = editorCore;
      const disabled = disabledHandler();

      if (view) {
        view.focus();
      }

      if (disabled) {
        return;
      }

      const {
        isOpen
      } = this.state;

      if (!isOpen) {
        this.setState({
          hasTooltip: false,
          isOpen: true
        });
        window.addEventListener("click", this.hidePopover);
      } else {
        this.hidePopover();
      }
    };

    this.handleMouseEnter = () => {
      if (this.state.isOpen) {
        return;
      }

      this.setState({
        hasTooltip: true
      });
    };

    this.state = {
      hasTooltip: false,
      isOpen: false,
      popoverPos: {},
      selected: props.selected || null
    };
  }

  componentDidMount() {
    const popoverPos = {
      left: 0,
      top: `${this.container.offsetHeight}px`
    };
    this.setState({
      popoverPos
    });
  } // 接收来自 Popover 的选中事件后，调用父级 transform 方法


  componentWillUnmount() {
    window.removeEventListener("click", this.hidePopover);
  }

  render() {
    const {
      type,
      disabledHandler,
      children
    } = this.props;
    const disabled = disabledHandler();
    const {
      hasTooltip,
      isOpen,
      selected,
      popoverPos
    } = this.state;
    const typeInfo = colorTypes.find(_ => _.type === type); // 设置表格边框颜色

    if (children && children.length) {
      return preact.h("div", {
        ref: container => this.container = container,
        onMouseEnter: () => {
          if (disabled) {
            return;
          }

          this.handleMouseEnter();
        },
        onMouseLeave: () => this.setState({
          hasTooltip: false
        }),
        onClick: this.handleClick,
        className: `toolbar-color-popover-wrapper ${type}-color${disabled ? " disabled" : ""}`
      }, children, isOpen && preact.h(Popover, {
        typeInfo: typeInfo,
        selected: selected,
        select: this.onSelect,
        displayPos: popoverPos
      }), hasTooltip && preact.h("div", {
        className: "ct-toolbar-tooltip"
      }, typeInfo.tip));
    }

    return preact.h("div", {
      ref: container => this.container = container,
      onMouseEnter: () => {
        if (disabled) {
          return;
        }

        this.handleMouseEnter();
      },
      onMouseLeave: () => this.setState({
        hasTooltip: false
      }),
      className: `toolbar-color-popover-wrapper ${type}-color${disabled ? " disabled" : ""}`
    }, type === "bg" && preact.h("div", {
      "data-action": "bgColor",
      className: "left",
      onClick: this.setColor
    }, preact.h("div", {
      className: "color",
      style: {
        background: selected || "#989898"
      }
    })), type === "font" && preact.h("div", {
      "data-action": "fontColor",
      className: "left",
      onClick: this.setColor
    }, preact.h("div", {
      className: "color",
      style: {
        background: selected || "#333",
        borderColor: selected ? selected === "#FFFFFF" ? "#eee" : selected : "#333"
      }
    })), type !== "border" && preact.h("div", {
      className: "right",
      onClick: this.handleClick
    }), isOpen && preact.h(Popover, {
      typeInfo: typeInfo,
      selected: selected,
      select: this.onSelect
    }), hasTooltip && preact.h("div", {
      className: "ct-toolbar-tooltip"
    }, typeInfo.tip));
  }

}

var css$1 = ".ct-table-model-pop-wrapper .ct-extra-popover{width:80px;left:-2px;padding:8px 0;position:absolute;top:26px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.ct-table-model-pop-wrapper .ct-extra-popover-item{padding-left:16px;height:30px;color:#333}.ct-p-pop-wrapper,.ct-table-model-pop-wrapper .ct-extra-popover-item{display:flex;justify-content:space-between;align-items:center;font-size:12px;transition:all .2s ease}.ct-p-pop-wrapper{position:relative;padding-left:10px;padding-right:5px;height:28px;width:80px;border-radius:2px;cursor:pointer;border:1px solid transparent;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 95% 56%}.ct-p-pop-wrapper:hover{border:1px solid #ccc}";
styleInject(css$1);

// @jsx h

class Popover$1 extends preact.Component {
  componentDidMount() {
    document.addEventListener('click', this.props.onGlobalClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.props.onGlobalClick);
  }

  render() {
    const {
      setResponsive,
      setFixed
    } = this.props;
    return preact.h("div", {
      className: "ct-extra-popover"
    }, preact.h("div", {
      "data-action": "tableFixed",
      className: "ct-extra-popover-item",
      onClick: setFixed
    }, preact.h("span", null, "\u56FA\u5B9A\u5BBD\u5EA6")), preact.h("div", {
      "data-action": "tableResponsive",
      className: "ct-extra-popover-item",
      onClick: setResponsive
    }, preact.h("span", null, "\u81EA\u9002\u5E94")));
  }

}

class ExtraPopover extends preact.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isOpen: false
    };

    this.onGlobalClick = () => {
      this.setState({
        isOpen: false
      });
    };

    this.handleClick = e => {
      const {
        view
      } = this.props.editor;
      view.focus();
      this.setState({
        isOpen: !this.state.isOpen
      });
      e.stopPropagation();
    };
  }

  render() {
    const {
      isResponsive,
      setResponsive,
      setFixed
    } = this.props;
    return preact.h("div", {
      onClick: this.handleClick,
      className: 'ct-p-pop-wrapper ct-table-model-pop-wrapper'
    }, isResponsive() ? '自适应' : '固定宽度', this.state.isOpen && preact.h(Popover$1, {
      setResponsive: setResponsive,
      setFixed: setFixed,
      onGlobalClick: this.onGlobalClick
    }));
  }

}

class TableMenu extends preact.Component {
  render() {
    const editor = this.props.getEditorCore();
    const state = editor.view.state;
    const {
      tableStore,
      tableCommands,
      tableUtils
    } = editor; // @ts-ignore

    const {
      hasRowHeader,
      hasColHeader,
      headerCol,
      hasNumCol,
      tableNode,
      startPos
    } = tableUtils ? tableUtils.hasTableHeader(state) : {};
    return !tableStore || !tableStore.isShowPopover ? null : preact.h("div", {
      className: "toolbar-secondary"
    }, preact.h(MenuItem, {
      action: "addRowBefore",
      tooltip: "\u4E0A\u65B9\u63D2\u5165\u884C",
      onClick: () => tableCommands.addRowBefore(),
      disabledHandler: () => tableUtils && !tableUtils.canAddRowBefore(state)
    }), preact.h(MenuItem, {
      action: "addRowAfter",
      tooltip: "\u4E0B\u65B9\u63D2\u5165\u884C",
      onClick: () => tableCommands.addRowAfter()
    }), preact.h(MenuItem, {
      action: "deleteRow",
      tooltip: "\u5220\u9664\u884C",
      onClick: () => tableCommands.deleteRow()
    }), preact.h("div", {
      className: "toolbar-split"
    }), preact.h(MenuItem, {
      action: "addColumnBefore",
      tooltip: "\u5DE6\u4FA7\u63D2\u5165\u5217",
      onClick: () => tableCommands.addColumnBefore(),
      disabledHandler: () => tableUtils && !tableUtils.canAddColumnBefore(state)
    }), preact.h(MenuItem, {
      action: "addColumnAfter",
      tooltip: "\u53F3\u4FA7\u63D2\u5165\u5217",
      onClick: () => tableCommands.addColumnAfter(),
      disabledHandler: () => tableUtils && !tableUtils.canAddColumnAfter(state)
    }), preact.h(MenuItem, {
      action: "deleteColumn",
      tooltip: "\u5220\u9664\u5217",
      onClick: () => tableCommands.deleteColumn()
    }), preact.h("div", {
      className: "toolbar-split"
    }), preact.h(MenuItem, {
      action: "mergeCells",
      tooltip: "\u5408\u5E76\u5355\u5143\u683C",
      onClick: () => tableCommands.mergeCells(),
      disabledHandler: () => tableUtils && !tableUtils.canMergeCells(state)
    }), preact.h(MenuItem, {
      action: "splitCell",
      tooltip: "\u62C6\u5206\u5355\u5143\u683C",
      onClick: () => tableCommands.splitCell(),
      disabledHandler: () => tableUtils && !tableUtils.canSplitCell(state)
    }), preact.h("div", {
      className: "toolbar-split"
    }), preact.h(MenuItem, {
      action: "tableRow",
      tooltip: hasRowHeader ? "取消表头行" : "设置表头行",
      onClick: () => tableCommands.toggleRowHeader(hasRowHeader, headerCol, hasNumCol, tableNode, startPos)
    }), preact.h(MenuItem, {
      action: "tableCol",
      tooltip: hasColHeader ? "取消表头列" : "设置表头列",
      onClick: () => tableCommands.toggleColHeader(hasColHeader, hasRowHeader, hasNumCol, tableNode, startPos),
      disabledHandler: () => hasRowHeader && tableNode.content.content.length === 1
    }), preact.h("div", {
      className: "toolbar-split"
    }), preact.h(ColorPopover, {
      editorCore: editor,
      disabledHandler: () => false,
      selected: tableStore && tableStore.selected,
      setSelected: s => {
        tableStore.selected = s;
      },
      type: "bg",
      setColor: c => tableCommands.setBgColor(c),
      setDefaultColor: () => tableCommands.setBgDefaultColor()
    }), preact.h("div", {
      className: "toolbar-split"
    }), preact.h(MenuItem, {
      action: "tableAttrs",
      tooltip: "\u8868\u683C\u5C5E\u6027",
      onClick: () => tableStore.showModal()
    }), preact.h(MenuItem, {
      action: "deleteTable",
      tooltip: "\u5220\u9664\u8868\u683C",
      onClick: () => tableCommands.deleteTable()
    }), preact.h("div", {
      className: "toolbar-split"
    }), preact.h(ExtraPopover, {
      editor: editor,
      isResponsive: () => tableUtils && !tableUtils.isResponsive(state),
      setResponsive: () => tableCommands.setResponsive(),
      setFixed: () => tableCommands.setFixed()
    }), preact.h("div", {
      className: "toolbar-split"
    }), preact.h("div", {
      className: "toolbar-numcol",
      onClick: () => tableCommands.toggleNumCol(hasNumCol, hasRowHeader, tableNode, startPos)
    }, preact.h(index_js.CheckBox, {
      checked: hasNumCol
    }), hasNumCol ? "取消行号列" : "设置行号列"));
  }

}

var css$2 = ".citadel-editor-toolbar{display:flex;justify-content:flex-start;align-items:center;flex-wrap:wrap;width:100%;min-height:50px;border-bottom:1px solid #eee;color:#555;padding:5px 10px 0}.citadel-editor-toolbar .toolbar-split{width:1px;height:15px;margin:auto 10px;background:#ddd}.citadel-editor-toolbar .toolbar-tooltip{position:absolute;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.citadel-editor-toolbar .toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;-webkit-transform:translate(50%);transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:\"\";z-index:1}.citadel-editor-toolbar .menu-item-wrapper{display:flex;flex-direction:row;margin-bottom:5px}.citadel-editor-toolbar .menu-item{position:relative;display:flex}.citadel-editor-toolbar .menu-item .disabled{pointer-events:none}.citadel-editor-toolbar .menu-item .toolbar-icon-wrapper{position:relative;width:28px;height:28px;margin:auto 5px;border-radius:2px;cursor:pointer;transition:all .2s ease;border:1px solid transparent;background-clip:content-box}.citadel-editor-toolbar .menu-item .toolbar-icon-wrapper[data-action=extra],.citadel-editor-toolbar .menu-item .toolbar-icon-wrapper[data-action=table]{width:45px}.citadel-editor-toolbar .menu-item:hover>.toolbar-icon-wrapper{border:1px solid #ccc}.citadel-editor-toolbar .menu-item.disabled>.toolbar-icon-wrapper{background-color:#fff;opacity:.3;cursor:not-allowed}.citadel-editor-toolbar .menu-item.active>.toolbar-icon-wrapper{border:1px solid #ccc;background-color:#eee}.citadel-editor-toolbar .toolbar-secondary{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;height:40px;margin-top:1px;padding-bottom:15px}.citadel-editor-toolbar .toolbar-secondary .toolbar-icon-wrapper:first-child{margin-left:0}.citadel-editor-toolbar .toolbar-secondary .toolbar-numcol{font-size:12px;color:#333;line-height:16px;display:flex;align-items:center}.citadel-editor-toolbar .toolbar-secondary .toolbar-color-popover-wrapper.bg-color .left{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='rotate(45 1.207 14.864)'%3E%3Crect stroke='%23666' fill-rule='nonzero' x='1.5' y='.5' width='7.5' height='7.5' rx='1'/%3E%3Cpath fill='%23666' d='M8.874.337l.191 7.658L1.52 7.69zM0 2h4v1H0z'/%3E%3C/g%3E%3Cpath d='M17.5 16a1.5 1.5 0 0 0 1.5-1.5c0-.552-.5-1.386-1.5-2.5-1 1.114-1.5 1.948-1.5 2.5a1.5 1.5 0 0 0 1.5 1.5z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-popover-wrapper{width:100px;padding:8px 0;position:absolute;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.toolbar-popover-wrapper .menu-item-wrapper.more>.menu-item{width:100px}.toolbar-popover-wrapper .menu-item-wrapper.more>.menu-item:after{content:\"\";position:absolute;width:9px;height:5px;right:8px;display:inline-block;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat;background-size:cover}.toolbar-popover-wrapper.fit{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.toolbar-popover-wrapper.fit .menu-item{padding:0 16px}.toolbar-popover-wrapper .menu-item{display:flex;align-items:center;width:100%;height:30px;padding-left:10px;font-size:12px;color:#333;cursor:pointer;transition:all .2s ease}.toolbar-popover-wrapper .menu-item:hover{background-color:#f6f6f6}.toolbar-popover-wrapper .menu-item:hover .toolbar-icon-wrapper{background-color:unset}.toolbar-popover-wrapper .menu-item>span{display:inline-block}.toolbar-popover-wrapper .menu-item .toolbar-icon-wrapper{width:16px;height:16px;margin-right:8px;margin-left:0}.toolbar-popover-wrapper .menu-item .toolbar-icon-wrapper:hover{background-color:unset}.toolbar-icon-wrapper{display:inline-block;background-repeat:no-repeat;background-size:cover}.toolbar-icon-wrapper[data-action=extra]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M14.5 12.5h3a.5.5 0 1 1 0 1h-3v3a.5.5 0 1 1-1 0v-3h-3a.5.5 0 1 1 0-1h3v-3a.5.5 0 1 1 1 0v3zM9 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9z' fill='%23666'/%3E%3Cpath fill='%23AEAEAE' d='M27 12h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=catalog]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1228 1024' xmlns='http://www.w3.org/2000/svg' width='19.188' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M368 192h480a48 48 0 1 1 0 96H368a48 48 0 0 1 0-96zm128 181.312h352a48 48 0 1 1 0 96H496a48 48 0 1 1 0-96zM368 554.688h480a48 48 0 1 1 0 96H368a48 48 0 0 1 0-96zM176 288a48 48 0 1 1 0-96 48 48 0 0 1 0 96zm0 362.688a48 48 0 1 1 0-96 48 48 0 0 1 0 96zm128-181.376a48 48 0 1 1 0-96 48 48 0 0 1 0 96zM496 736h352a48 48 0 1 1 0 96H496a48 48 0 1 1 0-96zm-192 96a48 48 0 1 1 0-96 48 48 0 0 1 0 96z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=attachment]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M148.864 415.808l288-279.04a31.552 31.552 0 0 1 43.648 0 30.272 30.272 0 0 1 0 42.88l-289.92 280.96c-85.376 85.888-85.376 224.448 3.968 308.352a233.152 233.152 0 0 0 321.728 0l339.584-327.808c57.6-54.656 57.6-144.384 0-199.04-57.6-54.592-148.928-54.592-204.544 0l-353.472 341.44h-1.984a60.48 60.48 0 0 0 0 85.888 63.104 63.104 0 0 0 87.36 0l1.984-1.92 295.872-284.928a31.552 31.552 0 0 1 43.712 0 30.272 30.272 0 0 1 0 42.944L428.928 712.32l-1.984 1.984a126.272 126.272 0 0 1-174.784 0 118.656 118.656 0 0 1 0-169.728l1.984-1.92 351.488-341.504 5.952-5.824c1.984-1.92 3.968-1.92 5.952-3.904 83.456-68.288 204.544-66.368 282.048 9.728 77.44 74.176 79.36 193.152 11.904 271.232-1.984 1.92-1.984 3.84-3.968 5.824l-7.936 7.808L560 813.824l-1.984 1.92c-113.28 107.328-295.936 107.328-409.152-1.92-113.152-111.232-113.152-288.768 0-398.08z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=drawio]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M800 704h57.6a38.4 38.4 0 0 1 38.4 38.4v115.2a38.4 38.4 0 0 1-38.4 38.4H678.4a38.4 38.4 0 0 1-38.4-38.4V742.4a38.4 38.4 0 0 1 38.4-38.4h55.104V576a32 32 0 0 0-32-32h-384a32 32 0 0 0-32 32v128H345.6a38.4 38.4 0 0 1 38.4 38.4v115.2a38.4 38.4 0 0 1-38.4 38.4H166.4a38.4 38.4 0 0 1-38.4-38.4V742.4a38.4 38.4 0 0 1 38.4-38.4H224V544a64 64 0 0 1 64-64h192V320h-57.6a38.4 38.4 0 0 1-38.4-38.4V166.4a38.4 38.4 0 0 1 38.4-38.4h179.2a38.4 38.4 0 0 1 38.4 38.4v115.2a38.4 38.4 0 0 1-38.4 38.4H544v160h192a64 64 0 0 1 64 64v160z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=status]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M192 704v64h640v-64H192zm-38.4-64h716.8c14.08 0 25.6 11.52 25.6 25.6v140.8a25.6 25.6 0 0 1-25.6 25.6H153.6a25.6 25.6 0 0 1-25.6-25.6V665.6c0-14.08 11.52-25.6 25.6-25.6zm0-448h716.8c14.08 0 25.6 11.52 25.6 25.6v140.8a25.6 25.6 0 0 1-25.6 25.6H153.6a25.6 25.6 0 0 1-25.6-25.6V217.6c0-14.08 11.52-25.6 25.6-25.6z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=quote]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.578 4v1.143c-.394.195-.69.548-.887 1.058-.197.51-.296 1.181-.296 2.015v.355H13V12H9.25V9.436c0-1.554.276-2.785.828-3.69.552-.907 1.385-1.489 2.5-1.746zm-6.25 0v1.143c-.394.195-.69.548-.887 1.058-.197.51-.296 1.181-.296 2.015v.355H6.75V12H3V9.436c0-1.554.276-2.785.828-3.69.552-.907 1.385-1.489 2.5-1.746z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=collapse]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(1 1)' fill-rule='nonzero' fill='none'%3E%3Cpath d='M11.934.5H4A1.5 1.5 0 0 0 2.5 2v11.5H10a1.5 1.5 0 0 0 1.5-1.5V4l.004-.062.43-3.438z' stroke='%23666' fill='%23FFF'/%3E%3Cpath d='M11.5 4.5h2v-3a1 1 0 0 0-2 0v3zM.5 10.5V12A1.5 1.5 0 0 0 2 13.5h7.5v-3h-9z' stroke='%23666' fill='%23FFF'/%3E%3Crect fill='%23666' x='4' y='3' width='6' height='1' rx='.5'/%3E%3Crect stroke='%23666' fill='%23FFF' x='8.5' y='8.5' width='3' height='5' rx='1.5'/%3E%3Cpath fill='%23FFF' d='M7 6h4v4H7z'/%3E%3Crect fill='%23666' x='4' y='6' width='6' height='1' rx='.5'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=latex]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill-rule='nonzero' fill='none'%3E%3Cpath d='M9 1.5c-1.307-.053-2.227.088-2.76.42C5.708 2.253 5.294 2.946 5 4L2.5 15' stroke='%236B6B6B'/%3E%3Cpath fill='%236B6B6B' d='M1 6h8v1H1z'/%3E%3Cpath d='M8 8l6 7M14 8l-6 7' stroke='%236B6B6B'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=html]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23666' fill-rule='evenodd'%3E%3Cpath d='M15 5h-1V3H2v2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2zm0 7v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2h1v2h12v-2h1zM6 7v4H5V7H4V6h3v1H6zm4.012.442L11 6.007V6h1v5h-1V7.75l-.709 1.013-.287.421L10 9.178l-.004.006-.438-.636L9 7.75V11H8V6h1v.007l1.012 1.435zM14 10h2v1h-3V6h1v4zM2 9H1v2H0V6h1v2h1V6h1v5H2V9z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=hr]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M162.88 416h698.24c19.2 0 34.88 14.336 34.88 32s-15.616 32-34.88 32H162.88c-19.2 0-34.88-14.336-34.88-32s15.616-32 34.88-32zm0 128h698.24c19.2 0 34.88 14.336 34.88 32s-15.616 32-34.88 32H162.88c-19.2 0-34.88-14.336-34.88-32s15.616-32 34.88-32z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=mention]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M553.792 658.88a222.72 222.72 0 0 1-59.008 48.128c-21.76 12.096-43.584 18.176-65.536 18.176a133.12 133.12 0 0 1-70.144-20.8c-22.656-13.824-41.152-35.136-55.296-63.872a210.688 210.688 0 0 1-21.312-94.592c0-42.304 11.008-84.672 33.024-127.104 22.08-42.496 49.408-74.304 82.112-95.616 32.704-21.312 64.512-32 95.36-32 23.488 0 45.888 6.144 67.264 18.24 21.376 12.096 39.68 30.528 55.168 55.296l13.76-61.888h72.576l-58.368 267.84c-8.128 37.248-12.16 57.856-12.16 61.888 0 7.168 2.752 13.376 8.32 18.56a28.288 28.288 0 0 0 20.032 7.744c14.336 0 33.152-8.128 56.32-24.32a224 224 0 0 0 73.28-85.632c17.92-35.84 26.88-72.704 26.88-110.72 0-44.48-11.52-86.016-34.56-124.608-23.168-38.592-57.6-69.44-103.424-92.608-45.824-23.168-96.448-34.688-151.872-34.688-63.296 0-121.024 14.528-173.376 43.712a301.376 301.376 0 0 0-121.6 125.312 368.768 368.768 0 0 0-43.2 175.04c0 65.216 14.4 121.344 43.136 168.448 28.8 47.104 70.4 81.92 124.928 104.32 54.464 22.528 114.816 33.792 181.056 33.792 70.784 0 130.176-11.712 177.984-35.136 47.872-23.424 83.712-51.84 107.52-85.44H896c-24.96 37.632-48.64 66.112-70.976 85.44a380.16 380.16 0 0 1-119.616 68.864C659.2 887.552 603.52 896 538.368 896a577.088 577.088 0 0 1-166.08-22.784c-50.688-15.168-93.824-37.952-129.536-68.48a303.488 303.488 0 0 1-80.64-105.152A391.104 391.104 0 0 1 128 536.768c0-64.96 13.504-126.848 40.576-185.6 32.96-72.128 79.808-127.36 140.48-165.696C369.728 147.2 443.328 128 529.856 128c67.008 0 127.232 13.504 180.608 40.512A299.52 299.52 0 0 1 836.8 289.28c26.24 46.08 39.36 96 39.36 150.08 0 77.184-27.584 145.664-82.752 205.568-49.216 53.76-103.04 80.64-161.408 80.64-18.624 0-33.728-2.816-45.184-8.384a54.336 54.336 0 0 1-25.344-23.936c-3.52-6.656-6.08-18.112-7.68-34.368zM357.504 550.72c0 36.48 8.768 64.768 26.368 84.992 17.536 20.224 37.76 30.336 60.416 30.336 15.104 0 31.104-4.48 47.872-13.312 16.704-8.96 32.768-22.208 48-39.744 15.296-17.536 27.776-39.872 37.504-66.88 9.728-27.008 14.592-54.08 14.592-81.216 0-36.16-9.088-64.256-27.328-84.224a87.04 87.04 0 0 0-66.688-29.952c-17.28 0-33.6 4.352-48.896 12.992s-30.08 22.528-44.416 41.728c-14.336 19.2-25.792 42.432-34.432 69.824a252.352 252.352 0 0 0-12.992 75.456z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=undo]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M19.5 18.5a11.621 11.621 0 0 0-7.996-5v3L6.5 12.1l5.004-4.6v3a9.198 9.198 0 0 1 7.996 8z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=redo]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M6.5 18.5a11.621 11.621 0 0 1 7.996-5v3l5.004-4.4-5.004-4.6v3a9.198 9.198 0 0 0-7.996 8z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=clearFormat]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M15.037 6.245l4.613 3.928c.424.362.47.992.1 1.408l-5.68 6.402L8.656 18 6.35 16.036a.984.984 0 0 1-.1-1.408l7.35-8.285a1.033 1.033 0 0 1 1.437-.098zm-4.009 4.519l4.612 3.928-2.004 2.26-4.626.026-1.607-1.368a.492.492 0 0 1-.05-.704l3.675-4.142zM6 19h14v1H6v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=bold]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M9.255 16.718c.097 1.08-.655 1.595-2.255 1.546V19h7.2c3.006-.098 4.606-1.276 4.8-3.533-.097-1.668-1.09-2.723-2.982-3.164v-.074c1.552-.294 2.327-1.03 2.327-2.208 0-.589-.242-1.153-.727-1.693-.824-.932-2.521-1.373-5.09-1.324-.583 0-1.6.049-3.055.147-.388 0-.921.024-1.6.073-.388.05-.63.074-.728.074v.736h.437c.727 0 1.188.098 1.382.294.194.148.29.59.29 1.325v7.065zm2.545-3.9c.194-.05.655-.074 1.382-.074 1.842.05 2.812.982 2.909 2.797 0 1.717-.873 2.576-2.618 2.576-1.164.098-1.721-.466-1.673-1.693v-3.606zm0-5.005c.29-.049.606-.073.945-.073 1.843 0 2.788.76 2.837 2.281-.049 1.325-.824 1.987-2.327 1.987H11.8V7.813z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=italic]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12.568 9.189l-2.176 7.698c-.202.905-.846 1.358-1.934 1.358h-.245L8 19h6.608l.213-.755h-.326c-1.157.05-1.565-.427-1.226-1.434l2.154-7.622c.27-.956.95-1.434 2.037-1.434h.327L18 7h-6.608l-.213.755h.245c1.102-.05 1.483.427 1.144 1.434z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=strikethrough]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='27' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.436 14H20v1.6h-1.964l1.464 3.9h-1.995l-1.364-3.894h-5.318L9.367 19.5H7.5l1.519-3.9H7V14h2.642l2.92-7.5h2.06l2.814 7.5zm-6.026 0h4.084l-1.98-5.57L11.41 14z' fill='%23666' fill-rule='nonzero'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=underline]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 17.9h12v1.6H7v-1.6zm7.82-10.488h-.405V6.5H18.2v.912h-.31c-.708-.03-1 .236-.972.874v5.041c-.036 2.329-1.358 3.537-3.895 3.573-2.629-.035-4.007-1.099-4.044-3.167V8.07c.028-.492-.179-.687-.723-.658H7.8V6.5h4.503v.912h-.406c-.507 0-.723.203-.723.67v5.646c.032 1.287.728 1.922 2.155 1.954 1.571-.032 2.337-.75 2.368-2.205V8.534c.03-.813-.243-1.151-.876-1.122z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=alignLeft]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 7.5h12v1H7v-1zm0 2h8v1H7v-1zm0 2h12v1H7v-1zm0 2h8v1H7v-1zm0 2h12v1H7v-1zm0 2h8v1H7v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=alignCenter]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 7.5h12v1H7v-1zm2 2h8v1H9v-1zm-2 2h12v1H7v-1zm2 2h8v1H9v-1zm-2 2h12v1H7v-1zm2 2h8v1H9v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=alignRight]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 7.5h12v1H7v-1zm4 2h8v1h-8v-1zm-4 2h12v1H7v-1zm4 2h8v1h-8v-1zm-4 2h12v1H7v-1zm4 2h8v1h-8v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=orderList]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M11 8h9v1h-9V8zm0 5h9v1h-9v-1zm0 5h9v1h-9v-1zM7.14 9.65V7.04H6v-.35c.145 0 .29-.01.434-.03.131-.02.26-.056.381-.11a.819.819 0 0 0 .288-.21.729.729 0 0 0 .161-.34h.4v3.65h-.527.003zm-.951 2.27c.06-.154.152-.294.27-.41.134-.117.288-.209.455-.27.2-.063.41-.093.619-.09.181-.003.362.02.536.07.157.037.306.105.437.2a.9.9 0 0 1 .402.78.941.941 0 0 1-.089.42 1.03 1.03 0 0 1-.239.33 1.878 1.878 0 0 1-.341.27c-.128.08-.26.15-.4.23a7.692 7.692 0 0 0-.784.41 1.728 1.728 0 0 0-.291.25.582.582 0 0 0-.158.3h2.255v.38H6c.015-.19.062-.376.14-.55.07-.146.164-.281.275-.4a2.31 2.31 0 0 1 .378-.3c.14-.08.287-.16.44-.24.186-.09.349-.18.489-.26.124-.072.242-.156.35-.25a.891.891 0 0 0 .21-.26.766.766 0 0 0 .072-.34.541.541 0 0 0-.068-.27.73.73 0 0 0-.452-.34 1.179 1.179 0 0 0-.329-.05.935.935 0 0 0-.393.08.823.823 0 0 0-.269.21.808.808 0 0 0-.152.29 1.037 1.037 0 0 0-.04.33h-.527a1.263 1.263 0 0 1 .065-.52zm1.035 5.94h.174c.107.002.215-.011.319-.04a.747.747 0 0 0 .266-.11.546.546 0 0 0 .183-.19.479.479 0 0 0 .068-.26.5.5 0 0 0-.223-.44 1.059 1.059 0 0 0-.557-.14 1.034 1.034 0 0 0-.37.06.717.717 0 0 0-.26.17.758.758 0 0 0-.151.26.866.866 0 0 0-.05.3h-.526c.004-.165.038-.327.1-.48.058-.14.145-.267.257-.37.122-.106.264-.188.418-.24.186-.063.383-.093.58-.09a2.22 2.22 0 0 1 .529.06c.15.035.294.096.425.18.25.16.397.443.384.74a.65.65 0 0 1-.174.44 1.1 1.1 0 0 1-.433.28V18c.232.03.445.144.6.32.13.161.199.363.195.57a.941.941 0 0 1-.121.48 1.115 1.115 0 0 1-.325.35c-.148.095-.31.166-.48.21a2.732 2.732 0 0 1-.585.07c-.205 0-.41-.026-.607-.08a1.311 1.311 0 0 1-.464-.23 1.064 1.064 0 0 1-.295-.37 1.162 1.162 0 0 1-.1-.51h.527a.8.8 0 0 0 .248.58c.191.16.438.24.687.22.122.002.245-.011.365-.04.105-.033.206-.08.3-.14a.769.769 0 0 0 .207-.22.589.589 0 0 0 .078-.3.607.607 0 0 0-.075-.3.653.653 0 0 0-.2-.22.872.872 0 0 0-.294-.14 1.442 1.442 0 0 0-.368-.04 3.093 3.093 0 0 0-.316.02v-.38a.115.115 0 0 0 .055.01h.009z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=bulletList]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M11 7.5h9v1h-9v-1zm-3.5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm3.5 6h9v1h-9v-1zm-3.5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm3.5 6h9v1h-9v-1zm-3.5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=taskList]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12.367 15.5a.567.567 0 0 1-.427-.16l-2.776-2.707a.537.537 0 0 1 0-.773.571.571 0 0 1 .793 0l2.453 2.392 3.695-3.602c.205-.2.537-.2.741 0 .205.2.205.523 0 .723l-4.079 3.977a.53.53 0 0 1-.4.15zM8 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H8z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=indentLess]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 8h12v1H7V8zm4 2h8v1h-8v-1zm0 2h8v1h-8v-1zm0 2h8v1h-8v-1zm0 2h8v1h-8v-1zm-4 2h12v1H7v-1zm2-7v4l-2-2 2-2z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=indentMore]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 8h12v1H7V8zm0 2h8v1H7v-1zm0 2h8v1H7v-1zm0 2h8v1H7v-1zm0 2h8v1H7v-1zm0 2h12v1H7v-1zm10-7l2 2-2 2v-4z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=table]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12 11v8h-1v-8H8v-1h12v1h-8zM9 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9zm3 7v-1h8v1h-8zm0 3v-1h8v1h-8z' fill='%23666'/%3E%3Cpath fill='%23AEAEAE' d='M27 12h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=link]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7.884 13.85l4.124-4.125 2.133 2.134a3.017 3.017 0 0 1 0 4.266l-1.99 1.991a3.017 3.017 0 0 1-4.267-4.266zm4.835-3.414l-.15.15a2.011 2.011 0 0 0 0 2.844l.712.711-.711.711.355.356-1.066-1.067a3.017 3.017 0 0 1 0-4.266l.149-.15.711.711zm.562 5.128l-1.842 1.841a2.011 2.011 0 0 1-2.844-2.844l1.99-1.991-.71-.711 3.975-3.975a3.017 3.017 0 0 1 4.266 4.266l-4.124 4.125-.711-.711zm-.562-5.128l.711.712-.71.71.71.712a2.011 2.011 0 0 1 0 2.844l-.15.15-.355-.356 1.067 1.067 2.133-2.134-.71-.71 1.99-1.992a2.011 2.011 0 0 0-2.844-2.844l-1.842 1.841z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=code]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.035 9.02c.267.073.432.331.368.575l-1.84 7.076c-.064.245-.332.383-.598.31-.267-.074-.432-.332-.368-.576l1.84-7.076c.064-.245.332-.383.598-.31zM7.207 13l2.475 2.475a.5.5 0 0 1-.707.707l-2.829-2.828a.498.498 0 0 1 0-.708l2.829-2.828a.5.5 0 0 1 .707.707L7.207 13zm11.586 0l-2.475-2.475a.5.5 0 1 1 .707-.707l2.829 2.828a.498.498 0 0 1 0 .708l-2.829 2.828a.5.5 0 1 1-.707-.707L18.793 13z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=note]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 1c3.826 0 7 3.173 7 7s-3.174 7-7 7c-3.827 0-7-3.173-7-7s3.173-7 7-7zm0 13c3.323 0 6-2.676 6-6s-2.677-6-6-6-6 2.676-6 6 2.677 6 6 6zm0-8.247a.877.877 0 1 1 0-1.754.877.877 0 0 1 0 1.754zM8 7a.75.75 0 0 1 .75.75v3.5a.75.75 0 1 1-1.5 0v-3.5A.75.75 0 0 1 8 7z' fill='%23666' fill-rule='nonzero'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=image]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M18 11.945V8.4a.4.4 0 0 0-.4-.4H8.4a.4.4 0 0 0-.4.4v5.566c1.677 1.356 3.343 1.367 5 .034s3.323-2.018 5-2.055zm0 .978c-.658-.016-1.214.052-1.667.203-1 .333-2.055.994-3.057 1.779-1.152.9-2.557 1.234-3.888.836-.355-.106-.818-.363-1.388-.77V17.6c0 .22.18.4.4.4h9.2a.4.4 0 0 0 .4-.4v-4.677zM17.745 7c.454 0 .777.127.968.38.191.253.287.584.287.993v9.574a.924.924 0 0 1-.087.38 1.074 1.074 0 0 1-.24.34c-.102.097-.22.177-.354.24a1.03 1.03 0 0 1-.44.093H8.04c-.276 0-.518-.111-.727-.333a1.126 1.126 0 0 1-.314-.8v-9.76c0-.32.089-.585.267-.794A.883.883 0 0 1 7.974 7h9.771zm-7.368 1.947a1.263 1.263 0 0 1 .888.367c.111.11.2.242.267.393.066.15.1.31.1.48 0 .346-.123.64-.367.88-.245.24-.54.36-.888.36-.169 0-.33-.031-.48-.094a1.144 1.144 0 0 1-.394-.266 1.398 1.398 0 0 1-.267-.394 1.161 1.161 0 0 1-.1-.486c0-.17.033-.33.1-.48.067-.151.156-.283.267-.394.111-.11.242-.2.394-.266.15-.067.311-.1.48-.1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=markdown]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M832 224v576a32 32 0 1 1-64 0V313.28L534.208 598.4a32 32 0 0 1-45.632-.192L256 313.472V800a32 32 0 1 1-64 0V224a32 32 0 0 1 32.64-32 32.32 32.32 0 0 1 26.048 14.336l260.864 319.36 265.792-324.352A32 32 0 0 1 832 224z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=experiment]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 1.5a.5.5 0 0 0-.5.5v4.202l-5.041 7.52a.5.5 0 0 0 .415.778h12.253a.5.5 0 0 0 .416-.778L9.5 6.188V2a.5.5 0 0 0-.5-.5H7z' stroke='%236B6B6B'/%3E%3Cpath fill='%236B6B6B' d='M5 1h6v1H5zM3.5 10h9v1h-9zM2.55 12H9v1H2z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=textExtra]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23666'%3E%3Cpath d='M11.07 20H9l8.262-12.744h1.602L21.456 20h-1.854l-.612-3.132h-5.976L11.07 20zm2.862-4.698h4.806l-1.08-6.048-3.726 6.048zM8.991 9.9h-.027c-.108.193-.282.35-.523.474-.24.123-.513.185-.82.185-.174 0-.355-.023-.544-.068a1.622 1.622 0 0 1-.523-.225 1.31 1.31 0 0 1-.396-.415A1.193 1.193 0 0 1 6 9.216c0-.324.092-.582.275-.775.183-.192.419-.339.707-.441.288-.102.608-.17.96-.203.35-.033.695-.05 1.031-.05V7.64c0-.27-.098-.47-.293-.6a1.236 1.236 0 0 0-.698-.193c-.228 0-.447.048-.658.144a1.77 1.77 0 0 0-.522.351l-.559-.657c.246-.229.53-.4.852-.514.32-.114.647-.171.977-.171.384 0 .701.054.95.162.25.108.446.25.59.424.145.174.245.369.302.585.057.216.086.433.086.649v2.63H8.991V9.9zm-.018-1.423H8.73c-.174 0-.358.008-.55.023-.192.015-.37.048-.531.1a1.135 1.135 0 0 0-.406.215.479.479 0 0 0-.162.383.46.46 0 0 0 .243.424.784.784 0 0 0 .244.09c.09.018.18.027.27.027.372 0 .654-.1.847-.298.192-.198.288-.468.288-.81v-.154z'/%3E%3C/g%3E%3Cpath fill='%23AEAEAE' d='M30 11.5h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=minder]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M5 8.5V9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5h1.03A4 4 0 0 1 10 4v-.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V5a3 3 0 0 0 0 6v-.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V12a4 4 0 0 1-3.97-3.5H5zm-1 0V7H2v2h2v-.5zm7-5v2h3v-2h-3zm0 7v2h3v-2h-3z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=sub]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M79.104 192h118.208L352 423.232 506.688 192h118.208L409.792 501.248 640 832H521.792L352 578.304 182.208 832H64l228.48-330.752L79.04 192zm877.888 590.08V832H747.264l1.024-13.76a119.04 119.04 0 0 1 10.24-39.808c5.12-10.56 11.776-20.224 20.16-29.184 8-7.872 16.768-14.848 26.752-21.12 9.152-5.248 18.688-10.432 28.992-15.808 10.048-4.864 19.456-9.92 30.4-16.192a131.84 131.84 0 0 0 20.544-14.72 43.84 43.84 0 0 0 10.112-12.288 36.8 36.8 0 0 0 3.456-16.512 21.632 21.632 0 0 0-2.624-10.688 33.664 33.664 0 0 0-21.568-15.872 62.784 62.784 0 0 0-17.536-2.688 46.72 46.72 0 0 0-19.392 3.84 39.68 39.68 0 0 0-12.928 10.048 38.976 38.976 0 0 0-7.296 14.016 53.568 53.568 0 0 0-2.112 17.024l.576 13.312h-58.88l-.96-11.712a93.632 93.632 0 0 1 4.864-38.528c4.608-12.032 11.52-22.528 20.928-31.68 9.728-8.576 20.992-15.232 33.728-19.84 14.08-4.48 28.8-6.656 43.2-6.4 12.864-.192 25.664 1.472 37.504 4.8 11.712 2.816 22.72 7.872 32 14.592A70.528 70.528 0 0 1 960 653.184a77.888 77.888 0 0 1-24.704 57.344c-7.36 7.232-15.424 13.632-24.128 19.072-3.84 2.368-7.808 4.672-13.056 7.68l-14.208 7.872c-7.04 3.136-13.44 6.272-25.472 12.48a359.808 359.808 0 0 0-22.656 12.608 98.048 98.048 0 0 0-14.208 11.84h135.424z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=sup]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M79.104 192h118.208L352 423.232 506.688 192h118.208L409.792 501.248 640 832H521.792L352 578.304 182.208 832H64l228.48-330.752L79.04 192zm877.888 208.64v49.92H747.264l1.024-13.76a119.04 119.04 0 0 1 10.24-39.808c5.12-10.56 11.776-20.224 20.16-29.184 8-7.808 16.768-14.848 26.752-21.12 9.152-5.248 18.688-10.432 28.992-15.808 10.048-4.864 19.456-9.92 30.4-16.192a131.84 131.84 0 0 0 20.544-14.72 43.84 43.84 0 0 0 10.112-12.288 36.8 36.8 0 0 0 3.456-16.448 21.632 21.632 0 0 0-2.624-10.752 33.664 33.664 0 0 0-21.568-15.872 62.784 62.784 0 0 0-17.536-2.688 46.72 46.72 0 0 0-19.392 3.84 39.68 39.68 0 0 0-12.928 10.048 38.976 38.976 0 0 0-7.296 14.016 53.568 53.568 0 0 0-2.112 17.024l.576 13.312h-58.88l-.96-11.712a93.632 93.632 0 0 1 4.864-38.528c4.608-12.032 11.52-22.528 20.928-31.68 9.728-8.576 20.992-15.232 33.728-19.84 14.08-4.48 28.8-6.592 43.2-6.4 12.864-.192 25.664 1.472 37.504 4.864 11.712 2.752 22.72 7.808 32 14.528A70.528 70.528 0 0 1 960 271.744a77.888 77.888 0 0 1-24.704 57.344c-7.36 7.232-15.424 13.696-24.128 19.072-3.84 2.368-7.808 4.672-13.056 7.68l-14.208 7.872c-7.04 3.136-13.44 6.272-25.472 12.48a359.808 359.808 0 0 0-22.656 12.608 98.048 98.048 0 0 0-14.208 11.84h135.424z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addRowBefore]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 8.5V10L6 8l2-2v1.5h3v1H8zm8.5 3.2V11h1v9H6v-1h10.5v-2.8H6v-1h10.5v-2.5H6v-1h10.5zM12 6.5h8v3h-8v-3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addRowAfter]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 17.5h3v1H8V20l-2-2 2-2v1.5zm8.5-3.2H6v-1h10.5v-2.5H6v-1h10.5V7H6V6h11.5v9h-1v-.7zM12 19.5h8v-3h-8v3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=deleteRow]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.214 13L20 14.786l-.714.714-1.786-1.786-1.786 1.786-.714-.714L16.786 13 15 11.214l.714-.714 1.786 1.786 1.786-1.786.714.714L18.214 13zM12 6h.5v4h-1V7H6V6h6zm-.5 13v-3h1v4H6v-1h5.5zm2.5-6.5h1v1h-1v1H6v-3h8v1z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addColumnBefore]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.5 8H10L8 6 6 8h1.5v3h1V8zm3.2 8.5H11v1h9V6h-1v10.5h-2.8V6h-1v10.5h-2.5V6h-1v10.5zM6.5 12v8h3v-8h-3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addColumnAfter]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.5 8H16l2-2 2 2h-1.5v3h-1V8zm-3.2 8.5h.7v1H6V6h1v10.5h2.8V6h1v10.5h2.5V6h1v10.5zm5.2-4.5v8h-3v-8h3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=deleteColumn]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 18.214L11.214 20l-.714-.714 1.786-1.786-1.786-1.786.714-.714L13 16.786 14.786 15l.714.714-1.786 1.786 1.786 1.786-.714.714L13 18.214zm7-5.714V6h-1v5.5h-3v1h4zm-13-1V6H6v6.5h4v-1H7zm6.5 2.5v1h-1v-1h-1V6h3v8h-1z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=mergeCells]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 15.5H6v-1h4V11H6v-1h4V7h1v3h4V7h1v3h4v1h-9v8h-1v-3.5zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=splitCell]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M19.197 14.5H20.5v1h-1.303v-1zm-8.697 0h1.303v1H10.5v-1zm4.348 0h1.304v1h-1.304v-1zm2.175 0h1.303v1h-1.303v-1zm-4.349 0h1.303v1h-1.303v-1zm3.352 3.697V19.5h-1v-1.303h1zm0-7.697v1.303h-1V10.5h1zm0 5.773v1.303h-1v-1.303h1zm0-3.849v1.303h-1v-1.303h1z' fill='%23999'/%3E%3Cpath d='M10 15.5H6v-1h4V11H6v-1h4V7h1v3h4V7h1v3h4v1h-9v8h-1v-3.5zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=tableRow]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 10v4h4v1h-4v4h-1v-4h-4v4h-1v-4H6v-1h4v-4H6V8v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8v2h-4zm-1 0h-4v4h4v-4zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=tableCol]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 14.5h5V11h-5v3.5zm0 1V19H7h12a1 1 0 0 0 1-1v-2.5h-4V19h-1v-3.5h-5zm10-1V8a1 1 0 0 0-1-1H7h3v3h5V7h1v3h4v1h-4v3.5h4zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=tableAttrs]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.495 13.5v3.013h-1V13.5H8.43v-1h4.066V9.487h1V12.5H17.571v1H13.495zm6.505-2v-2h1v2h-1zm0 3h1v2h-1v-2zm0 3h1v.5a2 2 0 0 1-2 2h-1.505v-1H19a1 1 0 0 0 1-1v-.5zM16.495 19v1h-2v-1h2zm-5 0v1h-2v-1h2zm-3 0v1H7a2 2 0 0 1-2-2v-.5h1v.5a1 1 0 0 0 1 1h1.495zM6 16.5H5v-2h1v2zm0-5H5v-2h1v2zm0-3H5V8a2 2 0 0 1 2-2h1.495v1H7a1 1 0 0 0-1 1v.5zM9.495 7V6h2v1h-2zm5 0V6h2v1h-2zm3 0V6H19a2 2 0 0 1 2 2v.5h-1V8a1 1 0 0 0-1-1h-1.505zM5 13.5v-1h2.286v1H5zm13.714 0v-1H21v1h-2.286zM12.495 6h1v2.325h-1V6zm0 11.675h1V20h-1v-2.325z' fill='%23333' fill-rule='nonzero'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=deleteTable]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.497 8.5H19.5a.5.5 0 0 1 0 .999h-13a.5.5 0 1 1 0-.999h3.003V8c0-1.105.854-2 1.908-2h3.178c1.054 0 1.908.895 1.908 2v.5zm-5.995 0h4.996V8c0-.552-.373-1-.833-1h-3.33c-.46 0-.833.448-.833 1v.5zm7.993 3.25v-.404 6.962c0 .934-.895 1.692-1.998 1.692H9.503c-1.103 0-1.998-.758-1.998-1.692v-6.962.403-.25a.5.5 0 1 1 1 0v6.671c0 .451.402.817.899.817h7.192c.497 0 .9-.366.9-.817V11.5a.5.5 0 1 1 .999 0v.25zm-7.493-.755a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.999 0v-6a.5.5 0 0 1 .499-.5zm3.996.004a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}";
styleInject(css$2);

class AlignMenuItem extends preact.Component {
  render() {
    const {
      editorCore
    } = this.props;
    const {
      basicCommands,
      basicUtils,
      view
    } = editorCore;

    if (!basicCommands || !basicUtils) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "alignLeft",
      tooltip: "\u5DE6\u5BF9\u9F50",
      activeHandler: () => basicUtils && basicUtils.isAlignedBlock(view.state, view, "left"),
      disabledHandler: () => !basicCommands || !basicUtils.canAlign(view.state, view),
      onClick: () => basicCommands.setAlign("left")
    }), preact.h(MenuItem, {
      action: "alignCenter",
      tooltip: "\u5C45\u4E2D\u5BF9\u9F50",
      activeHandler: () => basicUtils && basicUtils.isAlignedBlock(view.state, view, "center"),
      disabledHandler: () => !basicCommands || !basicUtils.canAlign(view.state, view),
      onClick: () => basicCommands.setAlign("center")
    }), preact.h(MenuItem, {
      action: "alignRight",
      tooltip: "\u53F3\u5BF9\u9F50",
      activeHandler: () => basicUtils && basicUtils.isAlignedBlock(view.state, view, "right"),
      disabledHandler: () => !basicCommands || !basicUtils.canAlign(view.state, view),
      onClick: () => basicCommands.setAlign("right")
    }));
  }

}

class AttachmentMenuItem extends preact.Component {
  constructor(...args) {
    super(...args);

    this.uploadAttachment = () => {
      const {
        attachmentStore
      } = this.props.editorCore;

      if (!attachmentStore) {
        return;
      }

      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("multiple", "true");

      input.onchange = e => {
        if (e.target && e.target.files) {
          attachmentStore.insertFiles(e.target.files);
          input.remove();
        }
      };

      input.click();
    };
  }

  render() {
    const {
      type,
      editorCore
    } = this.props;
    const {
      attachmentStore,
      view
    } = editorCore;

    if (!attachmentStore) {
      return "";
    }

    const isDisable = view.state && !index_js$1.canInsertTypes(view.state);
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "attachment",
      tooltip: "\u9644\u4EF6",
      disabledHandler: () => isDisable,
      onClick: this.uploadAttachment,
      type: type
    }));
  }

}

class BoldMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      view,
      codeUtils,
      basicCommands,
      basicUtils,
      view: {
        state: {
          schema
        }
      }
    } = editorCore;

    if (!basicCommands || !basicUtils) {
      return "";
    }

    const isInCode = codeUtils && codeUtils.isInCode(view.state);
    const isInHeading = basicUtils && basicUtils.isInHeading(view.state);
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "bold",
      tooltip: "\u7C97\u4F53",
      type: type,
      activeHandler: () => basicUtils && (basicUtils.hasMark(view.state, schema.marks.strong) || basicUtils.isInHeading(view.state)),
      disabledHandler: () => isInCode || isInHeading,
      onClick: () => basicCommands.toggleMark(schema.marks.strong)
    }));
  }

}

class BulletListMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      listUtils,
      view
    } = editorCore;

    if (!listUtils) {
      return "";
    }

    const {
      state: {
        schema
      }
    } = view;
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "bulletList",
      tooltip: "\u65E0\u5E8F\u5217\u8868",
      type: type,
      disabledHandler: () => view.state && !index_js$1.canInsertTypes(view.state),
      activeHandler: () => listUtils && listUtils.judgeListType(view.state, schema.nodes.bullet_list),
      onClick: () => {
        handleListClick(schema.nodes.bullet_list, editorCore);
      }
    }));
  }

}

class CatalogMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      catalogCommands
    } = editorCore;

    if (!catalogCommands) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "catalog",
      tooltip: "\u76EE\u5F55",
      onClick: catalogCommands.insert,
      type: type
    }));
    return "";
  }

}

class ClearFormatMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      codeUtils,
      basicCommands,
      basicUtils,
      view
    } = editorCore;

    if (!basicCommands || !basicUtils) {
      return "";
    }

    const isInCode = codeUtils && codeUtils.isInCode(view.state);
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "clearFormat",
      tooltip: "\u6E05\u9664\u683C\u5F0F",
      type: type,
      disabledHandler: () => isInCode || basicCommands && !basicUtils.isTextBlock(view.state),
      onClick: () => basicCommands.clearFormat()
    }));
  }

}

class CodeMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      codeCommands
    } = editorCore;

    if (!codeCommands) {
      return "";
    }

    const {
      view
    } = editorCore;
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "code",
      tooltip: "\u4EE3\u7801\u5757",
      type: type,
      disabledHandler: () => view.state && !index_js$1.canInsertTypes(view.state),
      onClick: () => codeCommands.insert()
    }));
  }

}

class CollapseMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      collapseCommands
    } = editorCore;

    if (!collapseCommands) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "collapse",
      tooltip: "\u5C55\u5F00",
      type: type,
      onClick: collapseCommands.insert
    }));
  }

}

class ColorMenuItem extends preact.Component {
  render() {
    const {
      editorCore
    } = this.props;
    const {
      codeUtils,
      view
    } = editorCore;

    if (!editorCore) {
      return "";
    }

    const isInCode = codeUtils && codeUtils.isInCode(view.state);
    return preact.h(ColorPopover, {
      type: "font",
      editorCore: editorCore,
      disabledHandler: () => isInCode
    });
  }

}

class DrawIOMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      drawioStore
    } = editorCore;

    if (!drawioStore) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "drawio",
      tooltip: "\u6D41\u7A0B\u56FE",
      type: type,
      onClick: () => drawioStore.create()
    }));
  }

}

class ExtraMenuItem extends preact.Component {
  constructor(...args) {
    super(...args);
    this.popover = void 0;
    this.container = void 0;
    this.state = {
      displayPos: {},
      isShowDropDown: false
    };

    this.showDropDown = e => {
      const {
        isShowDropDown
      } = this.state;

      if (!isShowDropDown) {
        const target = e.target;
        const displayPos = {
          left: `${target.offsetLeft}px`,
          top: `${target.offsetTop + target.offsetHeight}px`
        };
        this.setState({
          isShowDropDown: true,
          displayPos
        });
        window.addEventListener("click", this.hideDropDown);
      } else {
        this.hideDropDown();
      }
    };

    this.hideDropDown = e => {
      if (!e || e.target && !this.container.base.contains(e.target)) {
        this.setState({
          displayPos: {},
          isShowDropDown: false
        });
        window.removeEventListener("click", this.hideDropDown);
      }
    };
  }

  render() {
    const {
      isShowDropDown,
      displayPos
    } = this.state;
    const {
      editorCore,
      content,
      type
    } = this.props;
    const {
      view,
      codeUtils
    } = editorCore;
    const isInCode = codeUtils && codeUtils.isInCode(view.state);
    return preact.h(MenuItemWrapper, {
      ref: container => {
        this.container = container;
      }
    }, preact.h(MenuItem, {
      action: "extra",
      onClick: this.showDropDown,
      disabledHandler: () => isInCode,
      type: type
    }, isShowDropDown && preact.h("div", {
      style: displayPos,
      className: "toolbar-popover-wrapper",
      ref: popover => {
        this.popover = popover;
      },
      onClick: this.hideDropDown
    }, content)));
  }

}

class ExtraMoreMenuItem extends preact.Component {
  constructor(props) {
    super(props);
    this.container = void 0;
    this.popover = void 0;
    this.state = void 0;

    this.showMore = () => {
      const {
        isShowMore
      } = this.state;

      if (!isShowMore) {
        this.setState({
          isShowMore: true
        }, () => {
          const displayPos = caculatePopoverPos(this.container, this.popover);
          this.setState({
            displayPos
          });
        });
        setTimeout(() => {
          window.addEventListener("mousemove", this.hideMore);
        }, 200);
      }
    };

    this.hideMore = e => {
      if (!e || !e.target || !this.container.contains(e.target)) {
        this.setState({
          isShowMore: false,
          displayPos: {}
        });
        window.removeEventListener("mousemove", this.hideMore);
      }
    };

    this.renderExtraMore = () => {
      const {
        item
      } = this.props;
      const {
        isShowMore,
        displayPos
      } = this.state;

      if (!isShowMore || !item) {
        return;
      }

      return preact.h("div", {
        className: "toolbar-popover-wrapper fit",
        style: displayPos,
        ref: popover => {
          this.popover = popover;
        }
      }, renderExtraList(item.content, this.props.editorCore));
    };

    this.state = {
      displayPos: {},
      isShowMore: false
    };
    this.hideMore = throttle(this.hideMore, 100);
  }

  render() {
    const {
      item
    } = this.props;

    if (!item) {
      return "";
    }

    return preact.h(MenuItemWrapper, {
      getRef: container => {
        this.container = container;
      },
      isMore: true
    }, preact.h(MenuItem, {
      action: item.action,
      tooltip: item.title,
      onMouseEnter: this.showMore,
      type: "extra"
    }), this.renderExtraMore());
  }

}

class HistoryMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      historyCommands,
      historyUtils,
      view
    } = editorCore;

    if (!historyCommands || !historyUtils) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "undo",
      tooltip: "\u64A4\u9500",
      type: type,
      onClick: () => historyCommands.undo(),
      disabledHandler: () => !historyUtils || historyUtils.undoDepth(view.state) === 0
    }), preact.h(MenuItem, {
      action: "redo",
      tooltip: "\u91CD\u505A",
      type: type,
      onClick: () => historyCommands.redo(),
      disabledHandler: () => !historyUtils || historyUtils.redoDepth(view.state) === 0
    }));
  }

}

class HrMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      basicCommands
    } = editorCore;

    if (!basicCommands) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "hr",
      tooltip: "\u6C34\u5E73\u7EBF",
      onClick: basicCommands.insertHr,
      type: type
    }));
  }

}

class ImageMenuItem extends preact.Component {
  constructor(...args) {
    super(...args);

    this.uploadImage = () => {
      const {
        imageStore
      } = this.props.editorCore;

      if (!imageStore) {
        return;
      }

      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("multiple", "true");
      input.setAttribute("accept", "image/*");

      input.onchange = e => {
        imageStore.insertFiles(e.target.files);
        input.remove();
      };

      input.click();
    };
  }

  render() {
    const {
      type,
      editorCore
    } = this.props;
    const {
      imageStore,
      view
    } = editorCore;

    if (!imageStore) {
      return "";
    }

    const isDisable = view.state && !index_js$1.canInsertTypes(view.state);
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "image",
      tooltip: "\u56FE\u7247",
      type: type,
      disabledHandler: () => isDisable,
      onClick: this.uploadImage
    }));
  }

}

class IndentMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      basicCommands,
      basicUtils,
      listCommands,
      listUtils,
      tableCommands,
      tableUtils
    } = editorCore;

    if (!basicCommands || !listCommands || !tableCommands) {
      return "";
    }

    const {
      view
    } = editorCore;
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "indentLess",
      tooltip: "\u51CF\u5C11\u7F29\u8FDB",
      type: type,
      disabledHandler: () => {
        if (!basicUtils) {
          return true;
        }

        if (listUtils.isInList(view.state)) {
          return false;
        }

        if (tableUtils.canIndent(view.state, "less")) {
          return false;
        }

        return !basicUtils.canIndent(view.state, "less");
      },
      onClick: () => {
        if (!listCommands.liftListItem()) {
          if (!tableCommands.reduceIndent()) {
            basicCommands.setIndent("less");
          }
        }

        view.focus();
      }
    }), preact.h(MenuItem, {
      action: "indentMore",
      tooltip: "\u589E\u52A0\u7F29\u8FDB",
      type: type,
      disabledHandler: () => {
        if (!basicUtils) {
          return true;
        }

        if (listUtils.isInList(view.state)) {
          return false;
        }

        if (tableUtils.canIndent(view.state, "more")) {
          return false;
        }

        return !basicUtils.canIndent(view.state, "more");
      },
      onClick: () => {
        if (!listCommands.sinkListItem()) {
          if (!tableCommands.increaseIndent()) {
            basicCommands.setIndent("more");
          }
        }

        view.focus();
      }
    }));
  }

}

class ItalicMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      codeUtils,
      basicCommands,
      basicUtils,
      view
    } = editorCore;
    const {
      state: {
        schema
      }
    } = view;

    if (!basicCommands || !basicUtils) {
      return "";
    }

    const isInCode = codeUtils && codeUtils.isInCode(view.state);
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "italic",
      tooltip: "\u659C\u4F53",
      type: type,
      activeHandler: () => basicUtils && basicUtils.hasMark(view.state, schema.marks.em),
      disabledHandler: () => isInCode,
      onClick: () => basicCommands.toggleMark(schema.marks.em)
    }));
  }

}

class LatexMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      htmlStore,
      view: {
        state: {
          schema
        }
      }
    } = editorCore;

    if (!htmlStore) {
      return "";
    }

    if (type === "extra") {
      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
        action: "latex",
        tooltip: "\u516C\u5F0F",
        type: type,
        onClick: () => htmlStore.create(schema.nodes.markdown, "latex")
      }));
    }

    return "";
  }

}

class LinkMenuItem extends preact.Component {
  constructor(...args) {
    super(...args);

    this.addLink = () => {
      const {
        editorCore
      } = this.props;
      const {
        linkStore,
        linkUtils,
        view
      } = editorCore;
      const attrs = linkUtils.getLinkAttrs(view.state, view.dispatch);

      if (attrs) {
        linkStore.openModal(attrs, 0);
      }
    };
  }

  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      linkStore,
      linkUtils
    } = editorCore;

    if (!linkStore || !linkUtils) {
      return "";
    }

    const {
      view
    } = editorCore;
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "link",
      tooltip: "\u94FE\u63A5",
      type: type,
      activeHandler: () => linkUtils && linkUtils.hasLink(view.state),
      disabledHandler: () => view.state && !index_js$1.canInsertTypes(view.state),
      onClick: this.addLink
    }));
  }

}

class MarkdownMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      htmlStore,
      view: {
        state: {
          schema
        }
      }
    } = editorCore;

    if (!htmlStore) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      type: type,
      tooltip: "Markdown",
      onClick: () => htmlStore.create(schema.nodes.markdown, "markdown")
    }));
  }

}

class HTMLMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      htmlStore,
      view: {
        state: {
          schema
        }
      }
    } = editorCore;

    if (!htmlStore) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      type: type,
      tooltip: "HTML",
      onClick: () => htmlStore.create(schema.nodes.html, "html")
    }));
  }

}

class MentionMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      mentionStore
    } = editorCore;

    if (!mentionStore) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      type: type,
      action: "mention",
      tooltip: "\u7528\u6237\u63D0\u53CA",
      onClick: () => mentionStore.insertMention()
    }));
  }

}

class MinderMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      minderStore
    } = editorCore;

    if (!minderStore) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      type: type,
      action: "minder",
      tooltip: "\u601D\u7EF4\u5BFC\u56FE",
      onClick: () => minderStore.create()
    }));
  }

}

const noteSelectItem = [{
  title: "信息",
  type: "info"
}, {
  title: "警示",
  type: "note"
}, {
  title: "注意",
  type: "warning"
}, {
  title: "提示",
  type: "tip"
}];
class NoteMenuItem extends preact.Component {
  constructor(...args) {
    super(...args);
    this.container = void 0;
    this.popover = void 0;
    this.state = {
      displayPos: {},
      showSelect: false
    };

    this.showSelect = () => {
      const {
        showSelect
      } = this.state;

      if (!showSelect) {
        this.setState({
          showSelect: true
        }, () => {
          const displayPos = caculatePopoverPos(this.container, this.popover);
          this.setState({
            displayPos
          });
        });
        setTimeout(() => {
          window.addEventListener("mousemove", this.hideSelect);
        });
      }
    };

    this.hideSelect = e => {
      if (!e || !e.target || !this.container.contains(e.target)) {
        this.setState({
          showSelect: false
        });
        window.removeEventListener("mousemove", this.hideSelect);
      }
    };

    this.renderSelect = () => {
      const {
        showSelect,
        displayPos
      } = this.state;

      if (!showSelect) {
        return;
      }

      return preact.h("div", {
        className: "toolbar-popover-wrapper fit",
        style: displayPos,
        ref: popover => {
          this.popover = popover;
        }
      }, this.renderNoteSelectItem());
    };

    this.renderNoteSelectItem = () => {
      const {
        noteCommands
      } = this.props.editorCore;
      return noteSelectItem.map(({
        title,
        type
      }) => {
        const onClick = () => noteCommands.insert(type);

        return preact.h("div", {
          className: "menu-item",
          onClick: onClick
        }, title);
      });
    };
  }

  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      noteCommands
    } = editorCore;

    if (!noteCommands) {
      return "";
    }

    return preact.h(MenuItemWrapper, {
      getRef: container => {
        this.container = container;
      },
      isMore: true
    }, preact.h(MenuItem, {
      type: type,
      action: "note",
      tooltip: "\u6837\u5F0F",
      onMouseEnter: this.showSelect
    }), this.renderSelect());
  }

}

class OrderListMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      listUtils,
      view
    } = editorCore;

    if (!listUtils) {
      return "";
    }

    const {
      state: {
        schema
      }
    } = view;
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "orderList",
      tooltip: "\u6709\u5E8F\u5217\u8868",
      type: type,
      disabledHandler: () => view.state && !index_js$1.canInsertTypes(view.state),
      activeHandler: () => listUtils && listUtils.judgeListType(view.state, schema.nodes.ordered_list),
      onClick: () => {
        handleListClick(schema.nodes.ordered_list, editorCore);
      }
    }));
  }

}

class QuoteMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      quoteCommands,
      view
    } = editorCore;

    if (!quoteCommands) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      type: type,
      action: "quote",
      tooltip: "\u5F15\u7528",
      onClick: () => quoteCommands.toggle(view.state)
    }));
  }

}

class StatusMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      statusCommands
    } = editorCore;

    if (!statusCommands) {
      return "";
    }

    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "status",
      tooltip: "\u72B6\u6001",
      type: type,
      onClick: statusCommands.insert
    }));
  }

}

class StrikethroughMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      codeUtils,
      basicCommands,
      basicUtils,
      view
    } = editorCore;
    const {
      state: {
        schema
      }
    } = view;

    if (!basicCommands || !basicUtils) {
      return "";
    }

    const isInCode = codeUtils && codeUtils.isInCode(view.state);
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      action: "strikethrough",
      tooltip: "\u4E2D\u5212\u7EBF",
      type: type,
      activeHandler: () => basicUtils && basicUtils.hasMark(view.state, schema.marks.strikethrough),
      disabledHandler: () => isInCode,
      onClick: () => basicCommands.toggleMark(schema.marks.strikethrough)
    }));
  }

}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

var css$3 = ".toolbar-add-table-modal{position:fixed;padding:8px 8px 1px;background-color:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);font-size:12px;border-radius:2px;z-index:99}.toolbar-add-table-modal .container{border:1px solid #ddd;cursor:pointer}.toolbar-add-table-modal .row{height:18px;border-bottom:1px solid #ddd}.toolbar-add-table-modal .row:first-child{background-color:#f6f6f6}.toolbar-add-table-modal .row:last-child{height:17px;border-bottom:none}.toolbar-add-table-modal .block{display:inline-block;width:25px;height:100%;border-right:1px solid #ddd}.toolbar-add-table-modal .block:last-child{width:23px;border-right:none}.toolbar-add-table-modal .count{text-align:center}";
styleInject(css$3);

/** @jsx h */

class Popover$2 extends preact.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      bound: {
        rowCount: 4,
        colCount: 4
      },
      highlight: {
        rowNum: 0,
        colNum: 0
      }
    };

    this.onMouseMove = e => {
      const target = e.target;
      const row = target.getAttribute("data-row");
      const col = target.getAttribute("data-col");
      const {
        bound: {
          rowCount,
          colCount
        },
        highlight: {
          rowNum,
          colNum
        }
      } = this.state;
      let newRowCount = rowCount;
      let newColCount = colCount;

      if (row !== null) {
        if (row > 3) {
          newRowCount = +row + 1;
        } else {
          newRowCount = 4;
        }

        if (col > 3) {
          newColCount = +col + 1;
        } else {
          newColCount = 4;
        }

        this.setState({
          bound: {
            rowCount: newRowCount,
            colCount: newColCount
          },
          highlight: {
            rowNum: +row,
            colNum: +col
          }
        });
      } else {
        const limit = this.props.limit;
        const xDis = this.modal.offsetLeft + this.modal.offsetWidth - 8;
        const yDis = this.modal.offsetTop + this.modal.offsetHeight - 20;
        let newRowNum = rowNum;
        let newColNum = colNum;

        if (e.clientX > xDis) {
          if (colCount < limit.col) {
            newColCount = colCount + 1;
          }

          if (newColNum < newColCount - 1) {
            newColNum = newColCount - 1;
          }
        } else {
          newColNum = colCount - ~~((xDis - e.clientX) / 25 + 1);

          if (newColNum < 0) {
            newColNum = 0;
          }
        }

        if (e.clientY > yDis) {
          if (rowCount < limit.row) {
            newRowCount = rowCount + 1;
          }

          if (newRowNum < newRowCount - 1) {
            newRowNum = newRowCount - 1;
          }
        } else {
          newRowNum = rowCount - ~~((yDis - e.clientY) / 17 + 1);

          if (newRowNum < 0) {
            newRowNum = 0;
          }
        }

        this.setState({
          bound: {
            rowCount: newRowCount,
            colCount: newColCount
          },
          highlight: {
            rowNum: newRowNum,
            colNum: newColNum
          }
        });
      }
    };

    this.handleClick = () => {
      const {
        highlight: {
          rowNum,
          colNum
        }
      } = this.state;
      this.props.insertTable(rowNum + 1, colNum + 1);
    };
  }

  componentDidMount() {
    document.addEventListener("mousemove", this.onMouseMove);
  }

  componentWillUnmount() {
    document.removeEventListener("mousemove", this.onMouseMove);
  }

  render() {
    const {
      highlight: {
        rowNum,
        colNum
      },
      bound: {
        rowCount,
        colCount
      }
    } = this.state;
    const rows = [];

    for (let i = 0; i < rowCount; i++) {
      const blocks = [];

      for (let j = 0; j < colCount; j++) {
        if (rowNum >= i && colNum >= j) {
          blocks.push(preact.h("div", {
            key: j,
            "data-row": i,
            "data-col": j,
            className: "block",
            style: {
              backgroundColor: "rgba(240, 251, 255, 0.5)"
            }
          }));
        } else {
          blocks.push(preact.h("div", {
            key: j,
            "data-row": i,
            "data-col": j,
            className: "block"
          }));
        }
      }

      rows.push(preact.h("div", {
        className: "row",
        key: i
      }, blocks));
    }

    const width = `${118 + (colCount - 4) * 25}px`;
    return preact.h("div", {
      className: "toolbar-add-table-modal",
      style: objectSpread({}, this.props.style, {
        width
      }),
      onClick: this.handleClick,
      ref: div => {
        this.modal = div;
      }
    }, preact.h("div", {
      className: "container"
    }, rows), preact.h("div", {
      className: "count"
    }, `${rowNum + 1} X ${colNum + 1}`));
  }

} // 需由外部 ref 控制该弹框，故不使用装饰器注入 store，而采用 props 传递形式


class TablePopover extends preact.Component {
  constructor(...args) {
    super(...args);
    this.tableRef = null;
    this.state = {
      tablePopover: {
        style: {},
        visible: false
      }
    };

    this.closeTablePopover = e => {
      if (e.target && this.props.wrapper && !this.props.wrapper.base.contains(e.target) && this.state.tablePopover.visible && this.tableRef) {
        document.removeEventListener("click", this.closeTablePopover);
        this.setState({
          tablePopover: {
            visible: false
          }
        });
      }
    };

    this.toggle = e => {
      const visible = this.state.tablePopover.visible;

      if (visible) {
        document.removeEventListener("click", this.closeTablePopover);
        this.setState({
          tablePopover: {
            visible: false
          }
        });
      } else {
        document.addEventListener("click", this.closeTablePopover);
        this.setState({
          tablePopover: {
            style: {
              left: `${e.clientX - 20}px`,
              top: `${e.clientY + 15}px`
            },
            visible: true
          }
        });
      }
    };

    this.handleClick = (row, col) => {
      const {
        view,
        tableCommands
      } = this.props.editorCore;
      this.toggle();
      tableCommands.insertTable(row, col);
      view.focus();
    };
  }

  render() {
    const {
      tablePopover
    } = this.state;

    if (!tablePopover.visible) {
      return null;
    }

    return preact.h(Popover$2, {
      ref: target => {
        this.tableRef = target;
      },
      style: tablePopover.style,
      limit: {
        row: 15,
        col: 15
      },
      insertTable: this.handleClick
    });
  }

}

class TableMenuItem extends preact.Component {
  constructor(...args) {
    super(...args);
    this.tablePopover = void 0;
    this.wrapper = void 0;
  }

  componentDidMount() {
    this.forceUpdate();
  }

  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      view
    } = editorCore;
    const {
      tableCommands
    } = editorCore;

    if (!tableCommands) {
      return null;
    }

    return preact.h(MenuItemWrapper, {
      ref: wrapper => {
        this.wrapper = wrapper;
      }
    }, preact.h(MenuItem, {
      action: "table",
      tooltip: "\u8868\u683C",
      type: type,
      disabledHandler: () => view.state && !index_js$1.canInsertTypes(view.state),
      onClick: e => {
        this.tablePopover.toggle(e);
        view.focus();
      }
    }), preact.h(TablePopover, {
      editorCore: editorCore,
      wrapper: this.wrapper,
      ref: popover => {
        this.tablePopover = popover;
      }
    }));
  }

}

class TaskListMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      listUtils,
      view
    } = editorCore;

    if (!listUtils) {
      return "";
    }

    const {
      state: {
        schema
      }
    } = view;
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      type: type,
      action: "taskList",
      tooltip: "\u4EFB\u52A1\u5217\u8868",
      disabledHandler: () => view.state && !index_js$1.canInsertTypes(view.state),
      activeHandler: () => listUtils && listUtils.judgeListType(view.state, schema.nodes.task_list),
      onClick: () => {
        handleListClick(schema.nodes.task_list, editorCore);
      }
    }));
  }

}

var css$4 = ".toolbar-textExtra-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:45px;font-size:12px;cursor:pointer;transition:all .2s ease;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23666'%3E%3Cpath d='M11.07 20H9l8.262-12.744h1.602L21.456 20h-1.854l-.612-3.132h-5.976L11.07 20zm2.862-4.698h4.806l-1.08-6.048-3.726 6.048zM8.991 9.9h-.027c-.108.193-.282.35-.523.474-.24.123-.513.185-.82.185-.174 0-.355-.023-.544-.068a1.622 1.622 0 0 1-.523-.225 1.31 1.31 0 0 1-.396-.415A1.193 1.193 0 0 1 6 9.216c0-.324.092-.582.275-.775.183-.192.419-.339.707-.441.288-.102.608-.17.96-.203.35-.033.695-.05 1.031-.05V7.64c0-.27-.098-.47-.293-.6a1.236 1.236 0 0 0-.698-.193c-.228 0-.447.048-.658.144a1.77 1.77 0 0 0-.522.351l-.559-.657c.246-.229.53-.4.852-.514.32-.114.647-.171.977-.171.384 0 .701.054.95.162.25.108.446.25.59.424.145.174.245.369.302.585.057.216.086.433.086.649v2.63H8.991V9.9zm-.018-1.423H8.73c-.174 0-.358.008-.55.023-.192.015-.37.048-.531.1a1.135 1.135 0 0 0-.406.215.479.479 0 0 0-.162.383.46.46 0 0 0 .243.424.784.784 0 0 0 .244.09c.09.018.18.027.27.027.372 0 .654-.1.847-.298.192-.198.288-.468.288-.81v-.154z'/%3E%3C/g%3E%3Cpath fill='%23AEAEAE' d='M30 11.5h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\") no-repeat 50%}.toolbar-textExtra-popover-wrapper:hover{background-color:#ddd}.toolbar-textExtra-popover-wrapper.disabled{cursor:not-allowed}.toolbar-textExtra-popover-wrapper.disabled path{fill:#aaa}.toolbar-more-popover{width:80px!important;padding:8px 0}";
styleInject(css$4);

/** @jsx h */

class Popover$3 extends preact.Component {
  render() {
    const {
      displayPos = {}
    } = this.props;
    return preact.h("div", {
      className: "toolbar-popover-wrapper toolbar-more-popover",
      style: displayPos
    }, preact.h("div", {
      "data-action": "sup",
      className: "menu-item toolbar-more-popover-item",
      onClick: e => this.props.select("sup")
    }, preact.h("span", {
      className: "toolbar-icon-wrapper",
      "data-action": "sup"
    }), preact.h("span", null, "\u4E0A\u6807")), preact.h("div", {
      "data-action": "sub",
      className: "menu-item toolbar-more-popover-item",
      onClick: e => this.props.select("sub")
    }, preact.h("span", {
      className: "toolbar-icon-wrapper",
      "data-action": "sub"
    }), preact.h("span", null, "\u4E0B\u6807")));
  }

}

class MorePopover extends preact.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasTooltip: false,
      isOpen: false
    };

    this.onSelect = ops => {
      const {
        handler = {}
      } = this.props;

      if (typeof handler[ops] === "function") {
        return handler[ops]();
      }
    };

    this.hidePopover = e => {
      if (!e || e && e.target && !this.container.contains(e.target)) {
        this.setState({
          hasTooltip: false,
          isOpen: false
        });
        window.removeEventListener("click", this.hidePopover);
      }
    };

    this.componentDidMount = () => {
      const popoverPos = {
        left: 0,
        top: `${this.container.offsetHeight}px`
      };
      this.setState({
        popoverPos
      });
    };

    this.handleClick = e => {
      const {
        view
      } = this.props.editorCore;
      view.focus();
      const {
        isOpen
      } = this.state;

      if (!isOpen) {
        this.setState({
          hasTooltip: false,
          isOpen: true
        });
        window.addEventListener("click", this.hidePopover);
      } else {
        this.hidePopover();
      }
    };

    this.handleMouseEnter = () => {
      if (this.state.isOpen) {
        return;
      }

      this.setState({
        hasTooltip: true
      });
    };
  }

  render() {
    const {
      disabledHandler
    } = this.props;
    const disabled = disabledHandler && disabledHandler();
    const {
      popoverPos
    } = this.state;
    return preact.h("div", {
      onClick: !disabled ? this.handleClick : null,
      onMouseEnter: !disabled ? this.handleMouseEnter : null,
      onMouseLeave: () => this.setState({
        hasTooltip: false
      }),
      className: `toolbar-textExtra-popover-wrapper${disabled ? " disabled" : ""}`,
      ref: container => {
        this.container = container;
      }
    }, this.state.isOpen && preact.h(Popover$3, {
      select: this.onSelect,
      displayPos: popoverPos
    }), this.state.hasTooltip && preact.h("div", {
      className: "toolbar-tooltip",
      style: {
        width: "70px"
      }
    }, "\u6587\u5B57\u5176\u4ED6"));
  }

}

class TextExtraMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      codeUtils,
      basicCommands,
      view
    } = editorCore;
    const {
      state: {
        schema
      }
    } = view;

    if (!basicCommands) {
      return "";
    }

    const isInCode = codeUtils && codeUtils.isInCode(view.state);
    return preact.h(MorePopover, {
      type: type,
      editorCore: editorCore,
      disabledHandler: () => isInCode,
      handler: {
        sub: () => basicCommands.toggleSuMark(schema.marks.sub),
        sup: () => basicCommands.toggleSuMark(schema.marks.sup)
      }
    });
  }

}

var preactPortal = createCommonjsModule(function (module, exports) {
(function (global, factory) {
  module.exports = factory(preact__default);
}(commonjsGlobal, (function (preact) {
var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Portal = function (_Component) {
	inherits(Portal, _Component);

	function Portal() {
		classCallCheck(this, Portal);
		return possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Portal.prototype.componentDidUpdate = function componentDidUpdate(props) {
		for (var i in props) {
			if (props[i] !== this.props[i]) {
				return setTimeout(this.renderLayer);
			}
		}
	};

	Portal.prototype.componentDidMount = function componentDidMount() {
		this.isMounted = true;
		this.renderLayer = this.renderLayer.bind(this);
		this.renderLayer();
	};

	Portal.prototype.componentWillUnmount = function componentWillUnmount() {
		this.renderLayer(false);
		this.isMounted = false;
		if (this.remote) this.remote.parentNode.removeChild(this.remote);
	};

	Portal.prototype.findNode = function findNode(node) {
		return typeof node === 'string' ? document.querySelector(node) : node;
	};

	Portal.prototype.renderLayer = function renderLayer() {
		var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

		if (!this.isMounted) return;

		if (this.props.into !== this.intoPointer) {
			this.intoPointer = this.props.into;
			if (this.into && this.remote) {
				this.remote = preact.render(preact.h(PortalProxy, null), this.into, this.remote);
			}
			this.into = this.findNode(this.props.into);
		}

		this.remote = preact.render(preact.h(
			PortalProxy,
			{ context: this.context },
			show && this.props.children || null
		), this.into, this.remote);
	};

	Portal.prototype.render = function render() {
		return null;
	};

	return Portal;
}(preact.Component);

var PortalProxy = function (_Component2) {
	inherits(PortalProxy, _Component2);

	function PortalProxy() {
		classCallCheck(this, PortalProxy);
		return possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	PortalProxy.prototype.getChildContext = function getChildContext() {
		return this.props.context;
	};

	PortalProxy.prototype.render = function render(_ref) {
		var children = _ref.children;

		return children && children[0] || null;
	};

	return PortalProxy;
}(preact.Component);

return Portal;

})));

});

var DownIcon = (props => preact.h("svg", {
  width: "7px",
  height: "4px",
  viewBox: "0 0 7 4",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, preact.h("desc", null, "Created with Sketch."), preact.h("defs", null), preact.h("g", {
  id: "Page-1",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, preact.h("g", {
  id: "20\u3001\u5BCC\u6587\u672C\u7F16\u8F91",
  transform: "translate(-521.000000, -82.000000)",
  fill: "#AEAEAE"
}, preact.h("g", {
  id: "Group",
  transform: "translate(0.000000, 56.000000)"
}, preact.h("g", {
  id: "Group-8",
  transform: "translate(258.500000, 15.000000)"
}, preact.h("g", {
  id: "\u5B57\u53F7",
  transform: "translate(223.000000, 0.000000)"
}, preact.h("polygon", {
  id: "\u5F62\u72B6_32",
  points: "40 11.5 46 11.5 43 14.5"
}))))))));

var css$5 = ".ct-editor-dropdown-content{position:absolute;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);cursor:pointer;z-index:9999}.ct-editor-dropdown-container{position:relative;padding-left:10px;padding-right:5px;height:28px;font-size:12px;cursor:pointer;transition:all .2s ease}.ct-editor-dropdown-container,.ct-editor-dropdown-container .ct-dropdown-selected{display:flex;justify-content:space-between;align-items:center}.ct-editor-dropdown-container .ct-dropdown-selected svg{margin-left:20px;margin-right:5px}.ct-editor-dropdown-container .ct-toolbar-tooltip{display:none}.ct-editor-dropdown-container:hover{background-color:#ddd}.ct-editor-dropdown-container:hover .ct-toolbar-tooltip{display:block}.ct-editor-dropdown-container.disabled{cursor:not-allowed;color:#aaa}.ct-editor-dropdown-container.disabled .ct-dropdown-selected{cursor:not-allowed}";
styleInject(css$5);

/** @jsx h */
class Dropdown extends preact.Component {
  constructor(props) {
    super(props);
    this.ref = void 0;
    this.btn = void 0;
    this.state = {
      active: false
    };

    this.clickOutSide = e => {
      if (e.target === this.btn || this.btn.contains(e.target)) return;

      if (this.ref && !this.ref.contains(e.target)) {
        this.setState({
          active: false
        });
      }
    };

    this.onClick = () => {
      if (!this.props.disabled) this.setState({
        active: !this.state.active
      });
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.clickOutSide);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.clickOutSide);
  }

  render() {
    const {
      disabled,
      tooltip,
      width: menuWidth
    } = this.props;
    const {
      active
    } = this.state;
    const {
      top,
      left,
      width,
      height
    } = this.btn ? this.btn.getBoundingClientRect() : {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    };
    const style = {
      top: `${top + height}px`,
      left: `${left}px`,
      maxWidth: `${width + 100}px`
    };
    let selectBtnStyl = {};
    if (menuWidth) selectBtnStyl.width = `${menuWidth}px`;
    return preact.h("div", null, preact.h("div", {
      className: `ct-editor-dropdown-container ${disabled ? 'disabled' : ''}`,
      ref: ref => this.btn = ref,
      onClick: this.onClick
    }, preact.h("span", {
      className: `ct-dropdown-selected `,
      style: selectBtnStyl
    }, this.props.selected, preact.h(DownIcon, null)), preact.h("div", {
      className: "ct-toolbar-tooltip",
      style: {
        width: "70px"
      }
    }, tooltip), preact.h(preactPortal, {
      into: "body"
    }, active ? preact.h("div", {
      onClick: () => this.setState({
        active: false
      }),
      className: "ct-editor-dropdown-content",
      style: style,
      ref: ref => this.ref = ref
    }, this.props.children) : null)));
  }

}

var css$6 = ".toolbar-p-popover-item{margin:8px auto;padding-left:16px;padding-right:10px;color:#333;transition:all .2s ease}.toolbar-p-popover-item:hover{background:#f6f6f6}.toolbar-p-popover-item:not(:first-child){font-weight:700}.toolbar-p-popover-item:first-child{font-size:14px;line-height:24px}.toolbar-p-popover-item:nth-child(2){font-size:28px;line-height:42px}.toolbar-p-popover-item:nth-child(3){font-size:24px;line-height:36px}.toolbar-p-popover-item:nth-child(4){font-size:20px;line-height:30px}.toolbar-p-popover-item:nth-child(5){font-size:16px;line-height:24px}.toolbar-p-popover-item:nth-child(6){font-size:14px;line-height:21px}.toolbar-p-popover-item:nth-child(7){font-size:12px;line-height:18px}";
styleInject(css$6);

// () -> string

function uuid() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const id = [];

  for (let i = 0; i < 8; i++) {
    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
  }

  return id.join('');
}

/** @jsx h */

const textBlocks = [{
  type: "paragraph",
  text: "正文",
  keymap: "0"
}, {
  type: "heading_1",
  text: "一级标题",
  keymap: "1"
}, {
  type: "heading_2",
  text: "二级标题",
  keymap: "2"
}, {
  type: "heading_3",
  text: "三级标题",
  keymap: "3"
}, {
  type: "heading_4",
  text: "四级标题",
  keymap: "4"
}, {
  type: "heading_5",
  text: "五级标题",
  keymap: "5"
}, {
  type: "heading_6",
  text: "六级标题",
  keymap: "6"
}];
class BlockPopover extends preact.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasTooltip: false,
      isOpen: false
    };

    this.onSelect = type => {
      const {
        view,
        basicUtils,
        basicCommands
      } = this.props.editorCore;
      const {
        state: {
          schema
        }
      } = view;
      const currAttr = basicUtils.getAttrs(view.state);

      if (/heading_+/.test(type)) {
        const level = parseInt(type[8], 10);
        basicCommands.setTextBlockType(schema.nodes.heading, objectSpread({}, currAttr, {
          level,
          id: uuid()
        }));
      } else {
        basicCommands.setTextBlockType(schema.nodes.paragraph);
      }

      view.focus();
    };

    this.handleMouseEnter = () => {
      if (this.state.isOpen) {
        return;
      }

      this.setState({
        hasTooltip: true
      });
    };
  }

  render() {
    const {
      view,
      basicUtils
    } = this.props.editorCore;
    let label = basicUtils ? basicUtils.getTextBlockType(view.state) : null;
    const disabled = !label;
    return preact.h(Dropdown, {
      disabled: disabled,
      selected: label || "无效段落",
      tooltip: "\u6BB5\u843D\u683C\u5F0F",
      width: 80
    }, preact.h("div", null, textBlocks.map((b, index) => {
      return preact.h("div", {
        "data-action": "paragraph",
        key: `${b.type}-${index}`,
        className: "toolbar-p-popover-item",
        onClick: () => this.onSelect(b.type)
      }, b.text);
    })));
  }

}

class TitleMenuItem extends preact.Component {
  render() {
    const {
      editorCore
    } = this.props;

    if (!editorCore) {
      return "";
    }

    return preact.h(BlockPopover, {
      editorCore: editorCore
    });
  }

}

class UndelineMenuItem extends preact.Component {
  render() {
    const {
      editorCore,
      type
    } = this.props;
    const {
      codeUtils,
      basicCommands,
      basicUtils,
      view
    } = editorCore;
    const {
      state: {
        schema
      }
    } = view;

    if (!basicCommands || !basicUtils) {
      return "";
    }

    const isInCode = codeUtils && codeUtils.isInCode(view.state);
    return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
      type: type,
      action: "underline",
      tooltip: "\u4E0B\u5212\u7EBF",
      activeHandler: () => basicUtils && basicUtils.hasMark(view.state, schema.marks.underline),
      disabledHandler: () => isInCode,
      onClick: () => basicCommands.toggleMark(schema.marks.underline)
    }));
  }

}

var css$7 = ".citadel-editor-toolbar .fs-dp-item{margin:5px auto;padding:3px 16px;color:#333;transition:all .2s ease;font-weight:700;font-size:14px;line-height:16px}.citadel-editor-toolbar .fs-dp-item:hover{background:#f6f6f6}";
styleInject(css$7);

/** @jsx h */
const textBlocks$1 = [{
  type: "12",
  text: "9",
  keymap: "0"
}, {
  type: "13",
  text: "10",
  keymap: "1"
}, {
  type: "14",
  text: "11",
  keymap: "2"
}, {
  type: "16",
  text: "12",
  keymap: "3"
}, {
  type: "19",
  text: "14",
  keymap: "4"
}, {
  type: "22",
  text: "16",
  keymap: "5"
}, {
  type: "24",
  text: "18",
  keymap: "6"
}, {
  type: "29",
  text: "22",
  keymap: "7"
}, {
  type: "32",
  text: "24",
  keymap: "8"
}, {
  type: "40",
  text: "30",
  keymap: "9"
}, {
  type: "48",
  text: "36",
  keymap: "10"
}];
/**
 * 
 * @param {字体大小} type
 * 特殊逻辑判断 1级标题和3级标题的字号只能展示，不能出现选择，这里做特殊处理 
 */

const generateFontsize = type => {
  if (type === null) return {
    text: '11'
  };
  if (type === ' - ') return {
    text: ' - '
  };
  if (type === 28) return {
    text: 21
  };
  if (type === 20) return {
    text: 15
  };
  return textBlocks$1.filter(b => b.type === type.toString())[0];
};

class FontsizePopover extends preact.Component {
  constructor(...args) {
    super(...args);

    this.onSelect = size => {
      const {
        view,
        basicCommands
      } = this.props.editorCore;
      const {
        state: {
          selection,
          doc
        }
      } = view;
      basicCommands.setFontsize(size);
      /**
       *表格行号列时，判断第一个单元格是否为序列。
       如果是序列则不做处理
       */

      if (selection instanceof index_js$3.CellSelection) {
        const detectCell = selection.$headCell;
        const node = doc.nodeAt(detectCell.pos);

        if (node.attrs.numCell) {
          return;
        }
      }

      view.focus();
    };
  }

  render() {
    const {
      view,
      basicUtils
    } = this.props.editorCore;
    const fontSize = basicUtils ? basicUtils.getTextFontsize(view.state) : null;
    let label = generateFontsize(fontSize);
    const disabled = !basicUtils.canSetFontsize(view.state) || !label;
    return preact.h("div", null, preact.h(Dropdown, {
      selected: label.text,
      disabled: disabled,
      tooltip: "\u5B57\u4F53\u5927\u5C0F"
    }, textBlocks$1.map((block, index) => preact.h("div", {
      key: `${block.text}-${index}`,
      className: "fs-dp-item",
      onClick: () => this.onSelect(block.type)
    }, block.text))));
  }

}

class FontSizeMenuItem extends preact.Component {
  render() {
    const {
      editorCore
    } = this.props;

    if (!editorCore) {
      return "";
    }

    return preact.h(FontsizePopover, {
      editorCore: editorCore
    });
  }

}

const getMenuItem = (name, props) => {
  switch (name) {
    case "align":
      return preact.h(AlignMenuItem, props);

    case "attachment":
      return preact.h(AttachmentMenuItem, props);

    case "bold":
      return preact.h(BoldMenuItem, props);

    case "bulletList":
      return preact.h(BulletListMenuItem, props);

    case "catalog":
      return preact.h(CatalogMenuItem, props);

    case "clearFormat":
      return preact.h(ClearFormatMenuItem, props);

    case "code":
      return preact.h(CodeMenuItem, props);

    case "collapse":
      return preact.h(CollapseMenuItem, props);

    case "color":
      return preact.h(ColorMenuItem, props);

    case "drawio":
      return preact.h(DrawIOMenuItem, props);

    case "extra":
      return preact.h(ExtraMenuItem, props);

    case "extra_more":
      return preact.h(ExtraMoreMenuItem, props);

    case "history":
      return preact.h(HistoryMenuItem, props);

    case "hr":
      return preact.h(HrMenuItem, props);

    case "image":
      return preact.h(ImageMenuItem, props);

    case "indent":
      return preact.h(IndentMenuItem, props);

    case "italic":
      return preact.h(ItalicMenuItem, props);

    case "latex":
      return preact.h(LatexMenuItem, props);

    case "link":
      return preact.h(LinkMenuItem, props);

    case "markdown":
      return preact.h(MarkdownMenuItem, props);

    case "html":
      return preact.h(HTMLMenuItem, props);

    case "mention":
      return preact.h(MentionMenuItem, props);

    case "minder":
      return preact.h(MinderMenuItem, props);

    case "note":
      return preact.h(NoteMenuItem, props);

    case "orderList":
      return preact.h(OrderListMenuItem, props);

    case "quote":
      return preact.h(QuoteMenuItem, props);

    case "status":
      return preact.h(StatusMenuItem, props);

    case "strikethrough":
      return preact.h(StrikethroughMenuItem, props);

    case "table":
      return preact.h(TableMenuItem, props);

    case "taskList":
      return preact.h(TaskListMenuItem, props);

    case "textExtra":
      return preact.h(TextExtraMenuItem, props);

    case "title":
      return preact.h(TitleMenuItem, props);

    case "underline":
      return preact.h(UndelineMenuItem, props);

    case "fontSize":
      return preact.h(FontSizeMenuItem, props);
  }
};

const renderMenuBar = (menuBarConfig, editorCore) => menuBarConfig.map((item, idx) => renderItem(item, editorCore, idx === menuBarConfig.length - 1));
const renderItem = (itemList, editorCore, isLast = false) => {
  const menu = itemList.map(item => {
    if (typeof item === "string") {
      return getMenuItem(item, {
        editorCore
      });
    } else if (item.type === "extra") {
      return renderExtraMenu(item.content, editorCore);
    } else if (item.type === "custom") {
      return renderCustom(item);
    }
  });

  if (!isLast) {
    menu.push(preact.h("div", {
      className: "toolbar-split"
    }));
  }

  return menu;
};
const renderExtraMenu = (itemList, editorCore) => {
  const extraList = renderExtraList(itemList, editorCore);
  return getMenuItem("extra", {
    editorCore,
    content: extraList
  });
};
const renderExtraList = (itemList, editorCore) => {
  return itemList.map(item => {
    if (typeof item === "string") {
      return getMenuItem(item, {
        editorCore,
        type: "extra"
      });
    } else if (item.type === "more") {
      return getMenuItem("extra_more", {
        editorCore,
        item
      });
    } else if (item.type === "custom") {
      return renderCustom(item);
    }
  });
};
const renderCustom = item => {
  if (typeof item.render !== "function") {
    throw new Error("custom menu should have render menthod");
  }

  const container = document.createElement("div");
  return item.render(container);
};
const hasTable = config => {
  const queue = [config];

  while (queue.length !== 0) {
    const list = queue.shift();

    for (const item of list) {
      if (typeof item !== "string") {
        if (item.content) {
          queue.push(item.content);
        } else {
          queue.push(item);
        }
      } else {
        if (item === "table") {
          return true;
        }
      }
    }
  }

  return false;
};

class ToolBar extends preact.Component {
  getMenuBar() {
    const {
      getToolbarConfig,
      getEditorCore
    } = this.props;
    const editorCore = getEditorCore();
    const toolbarConfig = getToolbarConfig(editorCore);
    return renderMenuBar(toolbarConfig, editorCore);
  }

  getTableMenu() {
    const {
      getToolbarConfig,
      getEditorCore
    } = this.props;
    const toolbarConfig = getToolbarConfig(getEditorCore());
    const props = {
      getEditorCore
    };
    return hasTable(toolbarConfig) ? preact.h(TableMenu, props) : null;
  }

  render() {
    return preact.h("div", {
      className: "citadel-editor-toolbar"
    }, this.getMenuBar(), this.getTableMenu());
  }

}

// 工具栏交互相关代码

/** @jsx h */
const defaultGetToolbarConfig = editorCore => {
  if (!editorCore) {
    return [];
  }

  return [["history"], ["title", "fontSize", "clearFormat", "bold", "italic", "strikethrough", "underline", "color", "textExtra"], ["align"], ["bulletList", "orderList", "taskList", "indent"], ["table", "image", "link", "code", {
    content: ["catalog", "attachment", "drawio", "minder", "status", "quote", "collapse", "note", "latex", "html", "hr", "mention"],
    type: "extra"
  }]];
};

const buildToolbar = ({
  $toolbarWrapper,
  getEditorCore,
  getToolbarConfig
}) => {
  let count = 0;
  let toolbar;

  const renderComponent = () => {
    if (!$toolbarWrapper) {
      return;
    }

    toolbar = preact.render(preact.h(ToolBar, {
      key: count,
      getEditorCore: getEditorCore,
      getToolbarConfig: getToolbarConfig || defaultGetToolbarConfig
    }), $toolbarWrapper, $toolbarWrapper.firstChild);
  };

  const changeHandler = () => {
    count++;
    setTimeout(renderComponent);
  };

  renderComponent();
  const editor = getEditorCore();
  editor.on("update", changeHandler);
  editor.on("change", changeHandler);
  return () => {
    editor.off("update", changeHandler);
    editor.off("change", changeHandler);
    preact.render(null, $toolbarWrapper, toolbar);
  };
};

exports.buildToolbar = buildToolbar;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/toolbar/index.js